<!DOCTYPE html>
<html lang="uk">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#09090b">
    <meta name="mobile-web-app-capable" content="yes">
    <meta name="apple-mobile-web-app-capable" content="yes">
    <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
    <title>SyncFlow</title>
    <link rel="stylesheet" href="/src/css/index.css">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Montserrat:wght@300;400;500;600;700&family=Orbitron:wght@500;600;700;800;900&family=Share+Tech+Mono&display=swap">
    <link href="https://cdn.jsdelivr.net/npm/dseg@0.46.0/css/dseg.min.css" rel="stylesheet">
    <link rel="manifest" href="/manifest.json?v=5">
    <link rel="icon" type="image/png" sizes="32x32" href="/src/images/favicon-32x32-v2.png?v=5">
    <link rel="icon" type="image/png" sizes="16x16" href="/src/images/favicon-16x16-v2.png?v=5">
    <link rel="apple-touch-icon" sizes="180x180" href="/src/images/apple-touch-icon-v2.png?v=5">
    <link rel="shortcut icon" href="/src/images/favicon-32x32-v2.png?v=5">
    <link href="https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css" rel="stylesheet">
    <style>
        body.auth-pending {
            display: none !important;
        }
    </style>
    <!-- Vite handles caching -->
</head>

<body class="auth-pending">
    <div class="app-layout">
        <!-- Sidebar -->
        <aside class="sidebar" id="sidebar">
            <div class="sidebar-header">
                <div class="sidebar-profile" id="sidebar-profile-box" title="Перейти до профілю">
                    <div class="sidebar-avatar" id="sidebar-avatar">
                        <img src="data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 64 64%22%3E%3Crect width=%2264%22 height=%2264%22 rx=%2232%22 fill=%22%231e293b%22/%3E%3Cpath d=%22M32 34c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm0 5c-6.08 0-18 3.06-18 9.15V52h36v-3.85c0-6.09-11.92-9.15-18-9.15z%22 fill=%22%2394a3b8%22/%3E%3C/svg%3E" alt="avatar" id="sidebar-avatar-img" onerror="this.onerror=null; this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 64 64%22%3E%3Crect width=%2264%22 height=%2264%22 rx=%2232%22 fill=%22%231e293b%22/%3E%3Cpath d=%22M32 34c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm0 5c-6.08 0-18 3.06-18 9.15V52h36v-3.85c0-6.09-11.92-9.15-18-9.15z%22 fill=%22%2394a3b8%22/%3E%3C/svg%3E';">
                    </div>
                    <div class="sidebar-user-info">
                        <span class="sidebar-username" id="sidebar-username">Користувач</span>
                        <span class="sidebar-role" id="sidebar-role">SyncFlow</span>
                    </div>
                </div>
                <button class="sidebar-toggle" id="sidebar-toggle" data-tooltip="Згорнути" data-tooltip-pos="right">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M11 19l-7-7 7-7M18 19l-7-7 7-7" />
                    </svg>
                    <span class="sidebar-toggle-text">Згорнути меню</span>
                </button>
            </div>

            <nav class="sidebar-nav">
                <div class="sidebar-section">
                    <button class="sidebar-item active" data-tab="dashboard">
                        <i class="ri-layout-grid-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Дашборд</span>
                    </button>
                    <button class="sidebar-item" data-tab="slots">
                        <i class="ri-timer-flash-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Тайм-слоти</span>
                    </button>
                    <button class="sidebar-item" data-tab="notes">
                        <i class="ri-book-read-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Нотатки</span>
                    </button>
                    <button class="sidebar-item" data-tab="pomodoro">
                        <i class="ri-timer-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Помодоро</span>
                    </button>
                    <button class="sidebar-item" data-tab="tasks">
                        <i class="ri-checkbox-circle-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Завдання</span>
                    </button>
                    <button class="sidebar-item" data-tab="projects">
                        <i class="ri-folder-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Проекти</span>
                    </button>
                    <button class="sidebar-item" data-tab="statistics">
                        <i class="ri-bar-chart-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Статистика</span>
                    </button>
                </div>

                <div class="sidebar-section">
                    <span class="sidebar-section-title">Життя</span>
                    <button class="sidebar-item" data-tab="goals">
                        <i class="ri-focus-3-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Цілі</span>
                    </button>
                    <button class="sidebar-item" data-tab="habits" onclick="switchTab('habits')">
                        <i class="ri-calendar-check-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Звички</span>
                    </button>
                    <button class="sidebar-item" data-tab="finances">
                        <i class="ri-wallet-3-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Фінанси</span>
                    </button>
                    <button class="sidebar-item" data-tab="training">
                        <i class="ri-run-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Тренування</span>
                    </button>
                    <button class="sidebar-item" data-tab="photo-reports">
                        <i class="ri-gallery-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Фотозвіти</span>
                    </button>
                </div>

                <div class="sidebar-section">
                    <span class="sidebar-section-title">Розширення & Система</span>
                    <button class="sidebar-item" data-tab="profile">
                        <i class="ri-user-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Профіль</span>
                    </button>
                    <button class="sidebar-item" data-tab="settings">
                        <i class="ri-settings-4-line sidebar-item-icon"></i>
                        <span class="sidebar-item-text">Налаштування</span>
                    </button>
                </div>
            </nav>
        </aside>

        <!-- Main Content -->
        <main class="main-content">
            <div id="message-container" class="message-container is-hidden"></div>

            <div class="tab-container">
                <!-- Page Header (показується для кожної вкладки) -->
                <header class="page-header">
                    <div class="page-header-left">
                        <span class="page-breadcrumb" id="page-breadcrumb">SyncFlow</span>
                        <h1 class="page-title" id="page-title"><i class="ri-calendar-event-line sub-tab-icon"></i><span>Сьогодні</span></h1>
                    </div>
                    <div class="page-header-right">
                        <button class="btn-quick-capture-pill" id="btn-quick-capture" title="Швидкі дії (Ctrl + K)">
                            <i class="ri-command-line"></i>
                            <span class="cmd-kbd-hint">Ctrl K</span>
                        </button>
                        <div class="page-search search-container">
                            <i class="ri-search-line page-search-icon"></i>
                            <input type="text"
                                style="position: absolute; width: 0; height: 0; padding: 0; margin: 0; border: none; overflow: hidden;"
                                aria-hidden="true" autocomplete="username">
                            <input type="password"
                                style="position: absolute; width: 0; height: 0; padding: 0; margin: 0; border: none; overflow: hidden;"
                                aria-hidden="true" autocomplete="current-password">
                            <input type="search" placeholder="Пошук..." id="page-search-input" name="search-page-query"
                                data-tooltip="Гаряча клавіша: F"
                                autocomplete="new-password" autocorrect="off" spellcheck="false">
                            <button class="search-clear" id="page-search-clear" style="display: none;">
                                <i class="ri-close-line"></i>
                            </button>
                        </div>
                        <span class="search-results-count" id="search-results-count"></span>
                    </div>
                </header>

                <!-- Functional Tabs -->
                <div class="tab-content">
                    <div class="tab-panel active" id="dashboard">
                        <div class="tab-panel-header dashboard-panel-header">
                            <div class="dashboard-header-left">
                                <div class="dashboard-header-quote" id="dashboard-header-quote" title="Щоденна мотиваційна цитата">
                                    <div class="quote-lamp-icon"><i class="ri-lightbulb-flash-line"></i></div>
                                    <div class="dashboard-quote-content">
                                        <span class="dashboard-quote-text" id="dashboard-quote-text">"Завжди здається неможливим, поки це не зроблено."</span>
                                        <span class="dashboard-quote-author" id="dashboard-quote-author">— Нельсон Мандела</span>
                                    </div>
                                </div>
                                <span id="dashboard-greeting" style="display:none;"></span>
                                <span id="dashboard-date" style="display:none;"></span>
                            </div>
                            <div class="tab-header-right">
                                <div class="dashboard-quick-actions">
                                    <button class="btn btn-primary" id="dash-btn-add-task">
                                        <i class="ri-add-line"></i> <span>Завдання</span>
                                    </button>
                                    <button class="btn btn-secondary" id="dash-btn-add-expense">
                                        <i class="ri-wallet-3-line"></i> <span>Витрата</span>
                                    </button>
                                    <button class="btn btn-secondary" id="dash-btn-add-goal">
                                        <i class="ri-focus-3-line"></i> <span>Ціль</span>
                                    </button>
                                    <button class="btn btn-secondary btn-icon" id="dash-btn-widget-settings" title="Налаштування віджетів дашборду">
                                        <i class="ri-settings-3-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- KPI Summary Cards -->
                        <div class="dashboard-kpi-grid">
                            <div class="kpi-card" data-tab-target="tasks">
                                <div class="kpi-icon kpi-icon-blue">
                                    <i class="ri-checkbox-circle-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Завдання на сьогодні</span>
                                    <span class="kpi-value" id="dash-kpi-today-tasks">0</span>
                                    <span class="kpi-subtext" id="dash-kpi-total-active-tasks">Всього активних: 0</span>
                                </div>
                            </div>

                            <div class="kpi-card" data-tab-target="projects">
                                <div class="kpi-icon kpi-icon-purple">
                                    <i class="ri-folder-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Активні проєкти</span>
                                    <span class="kpi-value" id="dash-kpi-active-projects">0</span>
                                    <span class="kpi-subtext" id="dash-kpi-total-projects">Всього проєктів: 0</span>
                                </div>
                            </div>

                            <div class="kpi-card" data-tab-target="finances">
                                <div class="kpi-icon kpi-icon-green">
                                    <i class="ri-wallet-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Баланс місяця</span>
                                    <span class="kpi-value" id="dash-kpi-finance-balance">0 ₴</span>
                                    <span class="kpi-subtext" id="dash-kpi-finance-subtext">Доходи: 0 ₴ | Витрати: 0 ₴</span>
                                </div>
                            </div>

                            <div class="kpi-card" data-tab-target="goals">
                                <div class="kpi-icon kpi-icon-orange">
                                    <i class="ri-focus-3-line"></i>
                                </div>
                                <div class="kpi-details">
                                    <span class="kpi-label">Активні цілі</span>
                                    <span class="kpi-value" id="dash-kpi-active-goals">0</span>
                                    <span class="kpi-subtext" id="dash-kpi-goals-progress">Сер. прогрес: 0%</span>
                                </div>
                            </div>
                        </div>

                        <!-- Dashboard Widgets Grid (2-column balanced row pairs) -->
                        <div class="dashboard-content-grid">
                            <!-- Row 1: Завдання & Фінанси -->
                            <div class="dash-widget dash-widget-tasks">
                                <div class="dash-widget-header">
                                    <h3><i class="ri-calendar-check-line"></i> <span>Завдання на сьогодні</span></h3>
                                    <div class="dash-widget-header-right">
                                        <button class="dash-widget-btn-add" id="dash-widget-btn-add-task" data-dash-action="add-task"><i class="ri-add-line"></i> Додати</button>
                                        <button class="dash-widget-action" data-tab-target="tasks">Усі <i class="ri-arrow-right-line"></i></button>
                                    </div>
                                </div>
                                <div class="dash-widget-body">
                                    <div id="dash-today-tasks-list" class="dash-task-list">
                                        <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження завдань...</div>
                                    </div>
                                </div>
                            </div>

                            <div class="dash-widget dash-widget-finances">
                                <div class="dash-widget-header">
                                    <h3><i class="ri-pie-chart-line"></i> <span>Фінанси місяця</span></h3>
                                    <div class="dash-widget-header-right">
                                        <button class="dash-widget-btn-add" id="dash-widget-btn-add-expense" data-dash-action="add-expense"><i class="ri-wallet-3-line"></i> Витрата</button>
                                        <button class="dash-widget-action" data-tab-target="finances">Фінанси <i class="ri-arrow-right-line"></i></button>
                                    </div>
                                </div>
                                <div class="dash-widget-body">
                                    <div id="dash-finances-summary" class="dash-finance-box">
                                        <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження...</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Row 2: Проєкти & Тренування -->
                            <div class="dash-widget dash-widget-projects">
                                <div class="dash-widget-header">
                                    <h3><i class="ri-rocket-line"></i> <span>Активні проєкти</span></h3>
                                    <div class="dash-widget-header-right">
                                        <button class="dash-widget-btn-add" id="dash-btn-add-project" data-dash-action="add-project"><i class="ri-add-line"></i> Додати</button>
                                        <button class="dash-widget-action" data-tab-target="projects">Усі <i class="ri-arrow-right-line"></i></button>
                                    </div>
                                </div>
                                <div class="dash-widget-body">
                                    <div id="dash-active-projects-list" class="dash-projects-grid">
                                        <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження проєктів...</div>
                                    </div>
                                </div>
                            </div>

                            <div class="dash-widget dash-widget-training">
                                <div class="dash-widget-header">
                                    <h3><i class="ri-run-line"></i> <span>Останні тренування</span></h3>
                                    <div class="dash-widget-header-right">
                                        <button class="dash-widget-btn-add" id="dash-btn-add-training" data-dash-action="add-training"><i class="ri-add-line"></i> Додати</button>
                                        <button class="dash-widget-action" data-tab-target="training">Усі <i class="ri-arrow-right-line"></i></button>
                                    </div>
                                </div>
                                <div class="dash-widget-body">
                                    <div id="dash-training-summary" class="dash-training-box">
                                        <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження...</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Row 3: Цілі & Секундомір / Таймер -->
                            <div class="dash-widget dash-widget-goals">
                                <div class="dash-widget-header">
                                    <h3><i class="ri-trophy-line"></i> <span>Поточні цілі</span></h3>
                                    <div class="dash-widget-header-right">
                                        <button class="dash-widget-btn-add" id="dash-widget-btn-add-goal" data-dash-action="add-goal"><i class="ri-focus-3-line"></i> Додати</button>
                                        <button class="dash-widget-action" data-tab-target="goals">Усі <i class="ri-arrow-right-line"></i></button>
                                    </div>
                                </div>
                                <div class="dash-widget-body">
                                    <div id="dash-goals-list" class="dash-goals-list">
                                        <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження...</div>
                                    </div>
                                </div>
                            </div>

                            <div class="dash-widget dash-widget-timer">
                                <div class="dash-widget-header">
                                    <h3><i class="ri-timer-flash-line"></i> <span>Секундомір і таймер</span></h3>
                                </div>
                                <div class="dash-widget-body">
                                    <div class="standalone-timer-box">
                                        <div class="timer-mode-switcher">
                                            <button type="button" class="timer-mode-btn active" id="timer-mode-stopwatch"><i class="ri-time-line"></i> Секундомір</button>
                                            <button type="button" class="timer-mode-btn" id="timer-mode-countdown"><i class="ri-alarm-warning-line"></i> Відлік</button>
                                        </div>

                                        <div class="standalone-timer-display" id="standalone-timer-display">00:00:00</div>

                                        <div class="custom-timer-input-group" id="custom-timer-input-group" style="display: none;">
                                            <div class="custom-timer-inputs">
                                                <div class="custom-input-unit">
                                                    <input type="number" id="custom-timer-hrs" min="0" max="99" value="00" class="custom-timer-input">
                                                    <span class="custom-unit-label">год</span>
                                                </div>
                                                <span class="custom-sep">:</span>
                                                <div class="custom-input-unit">
                                                    <input type="number" id="custom-timer-mins" min="0" max="59" value="25" class="custom-timer-input">
                                                    <span class="custom-unit-label">хв</span>
                                                </div>
                                                <span class="custom-sep">:</span>
                                                <div class="custom-input-unit">
                                                    <input type="number" id="custom-timer-secs" min="0" max="59" value="00" class="custom-timer-input">
                                                    <span class="custom-unit-label">сек</span>
                                                </div>
                                            </div>
                                            <button type="button" class="preset-time-btn active" id="custom-timer-apply" title="Застосувати">
                                                <i class="ri-check-line"></i> Готово
                                            </button>
                                        </div>

                                        <div class="countdown-presets" id="countdown-presets" style="display: none;">
                                            <button type="button" class="preset-time-btn" data-mins="5">5хв</button>
                                            <button type="button" class="preset-time-btn" data-mins="15">15хв</button>
                                            <button type="button" class="preset-time-btn active" data-mins="25">25хв</button>
                                            <button type="button" class="preset-time-btn" data-mins="45">45хв</button>
                                            <button type="button" class="preset-time-btn" data-mins="60">60хв</button>
                                            <button type="button" class="preset-time-btn custom-preset-btn" id="custom-timer-toggle-btn" title="Вказати власний час"><i class="ri-edit-line"></i> Свій</button>
                                        </div>

                                        <div class="standalone-timer-controls">
                                            <button type="button" class="standalone-timer-btn btn-start" id="standalone-timer-start">
                                                <i class="ri-play-fill"></i> Старт
                                            </button>
                                            <button type="button" class="standalone-timer-btn btn-pause" id="standalone-timer-pause" style="display: none;">
                                                <i class="ri-pause-fill"></i> Пауза
                                            </button>
                                            <button type="button" class="standalone-timer-btn btn-lap" id="standalone-timer-lap" style="display: none;">
                                                <i class="ri-flag-2-line"></i> Коло
                                            </button>
                                            <button type="button" class="standalone-timer-btn btn-reset" id="standalone-timer-reset">
                                                <i class="ri-refresh-line"></i> Скинути
                                            </button>
                                        </div>

                                        <div class="timer-laps-container" id="timer-laps-container" style="display: none;">
                                            <div class="timer-laps-list" id="timer-laps-list"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dashboard-bottom-spacer"></div>
                    </div>

                    <!-- SLOTS & FINANCIAL TARGET TAB -->
                    <div class="tab-panel" id="slots">
                        <div class="slots-hero-bar">
                            <div class="slots-hero-left">
                                <i class="ri-timer-flash-line slots-header-ico"></i>
                                <span class="slots-hero-title">Система Слотів</span>
                                <span class="slots-hero-badge" id="slots-header-sub">Планка: <strong>$1 000 (~44 800 грн)</strong></span>
                                <div class="slots-hero-live-pill" id="slots-live-card">
                                    <span class="slots-live-dot-static"></span>
                                    <i id="slots-live-icon" class="ri-time-line slots-live-icon"></i>
                                    <span class="slots-live-label">Зараз:</span>
                                    <strong id="slots-live-title" class="slots-live-title">Завантаження розкладу...</strong>
                                    <span class="slots-live-sep">•</span>
                                    <span id="slots-live-countdown" class="slots-live-countdown"></span>
                                    <p id="slots-live-desc" class="slots-live-desc" style="display:none;"></p>
                                </div>
                            </div>
                            <div class="slots-hero-actions">
                                <button class="slots-btn-hero slots-btn-hero-primary" onclick="openSlotsReportModal()" data-tooltip="Зафіксувати підсумки дня" data-tooltip-pos="bottom">
                                    <i class="ri-check-double-line"></i>
                                    <span>Фіксація дня</span>
                                </button>
                                <button class="slots-btn-hero" onclick="openSlotsHistoryModal()" data-tooltip="Переглянути історію за 14 днів" data-tooltip-pos="bottom">
                                    <i class="ri-history-line"></i>
                                    <span>Історія</span>
                                </button>
                                <button class="slots-btn-hero slots-refresh-btn" id="slots-btn-refresh" onclick="refreshSlotsData()" data-tooltip="Оновити дані" data-tooltip-pos="bottom">
                                    <i class="ri-refresh-line"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Main 2-Column Slots Workspace -->
                        <div class="slots-workspace">
                            <!-- Left: Interactive Visual Timeline Planner -->
                            <div class="slots-workspace-main">
                                <div id="weekly-planner-root"></div>
                            </div>

                            <!-- Right: Goal Tracking & Metric Sidebar -->
                            <div class="slots-workspace-sidebar">
                                <!-- Card 1: Delivery Quota & Weekend Buffer -->
                                <div class="slots-widget-card">
                                    <div class="slots-widget-header">
                                        <div class="slots-widget-title">
                                            <i class="ri-riding-line" style="color:var(--brand-orange,#f97316);"></i>
                                            <span>Доставка</span>
                                        </div>
                                        <span id="slots-week-status-badge" class="slots-badge badge-info">...</span>
                                    </div>
                                    <div class="slots-widget-body">
                                        <div class="slots-income-summary">
                                            <div class="slots-income-header-line">
                                                <span class="slots-metric-label">План у розкладі</span>
                                                <span class="slots-metric-pct pct-orange" id="slots-week-pct">0%</span>
                                            </div>
                                            <div class="slots-income-value-line">
                                                <strong id="slots-week-hours" class="slots-income-main-val" style="color:var(--brand-orange,#f97316);">0.0 год</strong>
                                                <span class="slots-income-target-val" id="slots-week-quota">з 25.0 год</span>
                                            </div>
                                        </div>
                                        <div class="slots-progress-bar">
                                            <div id="slots-week-progress-fill" class="slots-progress-fill" style="width:0%"></div>
                                        </div>
                                        <div class="slots-submetrics">
                                            <div class="slots-submetric-item">
                                                <span>Заробіток</span>
                                                <strong id="slots-week-earnings">0 грн</strong>
                                            </div>
                                            <div class="slots-submetric-item">
                                                <span>Сер. рейт</span>
                                                <strong id="slots-week-rate">0 грн/год</strong>
                                            </div>
                                        </div>
                                        <div class="slots-buffer-hint">
                                            <i class="ri-information-line"></i>
                                            <span>Пн–Пт: 4 год (18:30) · Сб: 5 год (17:00) · Нд: буфер</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Card 2: USD Monthly Target -->
                                <div class="slots-widget-card">
                                    <div class="slots-widget-header">
                                        <div class="slots-widget-title">
                                            <i class="ri-money-dollar-circle-line" style="color:var(--color-success,#10b981);"></i>
                                            <span>Планка місяця</span>
                                        </div>
                                        <div class="slots-widget-header-right">
                                            <span id="slots-month-remaining" class="slots-metric-hint">Розрахунок...</span>
                                            <button type="button" class="slots-header-link-btn" onclick="openSlotsSettingsModal()" title="Налаштувати плани (Ліцей, ПУМ, Доставка)">
                                                <i class="ri-settings-4-line"></i>
                                            </button>
                                            <button type="button" class="slots-header-link-btn" onclick="window.navigateToIncomes && window.navigateToIncomes()" title="Перейти у вкладку «Доходи»">
                                                <i class="ri-external-link-line"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="slots-widget-body">
                                        <div class="slots-income-summary">
                                            <div class="slots-income-header-line">
                                                <span class="slots-metric-label">Загальний дохід</span>
                                                <div style="display:flex;align-items:center;gap:6px;">
                                                    <span class="slots-global-target-badge" id="slots-global-target-badge" title="Загальна стратегічна ціль: $1 000">
                                                        <i class="ri-flag-2-fill"></i> Ціль $1 000
                                                    </span>
                                                    <span class="slots-metric-pct" id="slots-month-pct">0%</span>
                                                </div>
                                            </div>
                                            <div class="slots-income-value-line">
                                                <strong id="slots-month-total" class="slots-income-main-val">0 грн</strong>
                                                <span class="slots-income-target-val" id="slots-month-target">/ 0 грн</span>
                                            </div>
                                        </div>
                                        <div class="slots-progress-bar">
                                            <div id="slots-month-fill" class="slots-progress-fill fill-green" style="width:0%"></div>
                                        </div>
                                        <div class="slots-breakdown-compact" onclick="openSlotsSettingsModal()" title="Натисніть, щоб налаштувати планові цифри" style="cursor:pointer;">
                                            <div class="slots-breakdown-row">
                                                <span><i class="ri-book-read-line" style="color:#f59e0b"></i> Ліцей</span>
                                                <strong id="slots-month-school">0 грн <span class="slots-plan-hint">(план ~15.5к)</span></strong>
                                            </div>
                                            <div class="slots-breakdown-row">
                                                <span><i class="ri-macbook-line" style="color:#0ea5e9"></i> ПУМ</span>
                                                <strong id="slots-month-pum">0 грн <span class="slots-plan-hint">(план ~6к)</span></strong>
                                            </div>
                                            <div class="slots-breakdown-row">
                                                <span><i class="ri-riding-line" style="color:#f97316"></i> Доставка</span>
                                                <strong id="slots-month-delivery" style="color:var(--brand-orange,#f97316);">0 грн <span class="slots-plan-hint">(план ~23.5к)</span></strong>
                                            </div>
                                            <div class="slots-breakdown-row" id="slots-month-other-row" style="display:none;">
                                                <span><i class="ri-wallet-3-line" style="color:#10b981"></i> Інше</span>
                                                <strong id="slots-month-other" style="color:#10b981;">0 грн</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Card 3: Daily Time Balance & Sleep -->
                                <div class="slots-widget-card">
                                    <div class="slots-widget-header">
                                        <div class="slots-widget-title">
                                            <i class="ri-heart-pulse-line" style="color:#8b5cf6;"></i>
                                            <span>Баланс & Сон</span>
                                        </div>
                                        <span class="slots-badge badge-purple">9 год сну</span>
                                    </div>
                                    <div class="slots-widget-body">
                                        <div class="slots-pie-summary">
                                            <div class="slots-pie-item">
                                                <span class="dot" style="background:#ef4444;"></span>
                                                <span>Робота: <strong>10.0 год</strong></span>
                                            </div>
                                            <div class="slots-pie-item">
                                                <span class="dot" style="background:#64748b;"></span>
                                                <span>Логістика: <strong>2.0 год</strong></span>
                                            </div>
                                            <div class="slots-pie-item">
                                                <span class="dot" style="background:#3b82f6;"></span>
                                                <span>Вільний час: <strong>3.0 год</strong></span>
                                            </div>
                                            <div class="slots-pie-item">
                                                <span class="dot" style="background:#8b5cf6;"></span>
                                                <span>Сон: <strong>9.0 год</strong></span>
                                            </div>
                                        </div>
                                        <div class="slots-sleep-rule">
                                            <i class="ri-shield-star-line"></i>
                                            <span><strong>Вікно сну:</strong> 00:00–09:00 (9 год без компромісів)</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Quick Report Launcher -->
                                <button class="slots-sidebar-action-btn" onclick="openSlotsReportModal()">
                                    <i class="ri-edit-circle-line"></i>
                                    <span>Внести дані дня (22:30–00:00)</span>
                                </button>
                            </div>
                        </div>

                        <!-- Modal: Daily Report Form -->
                        <div class="slots-modal-overlay" id="slots-report-modal" style="display:none;">
                            <div class="slots-modal-card">
                                <div class="slots-modal-header">
                                    <div class="slots-modal-title">
                                        <i class="ri-edit-circle-line" style="color:var(--brand-primary,#3b82f6)"></i>
                                        <h3>Фіксація звітного дня</h3>
                                    </div>
                                    <button class="slots-modal-close" onclick="closeSlotsReportModal()"><i class="ri-close-line"></i></button>
                                </div>
                                <div class="slots-modal-body">
                                    <div class="slots-form-grid">
                                        <div class="slots-form-group">
                                            <label>Дата звіту</label>
                                            <input type="date" id="slot-input-date" class="slots-input">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>ПУМ (год)</label>
                                            <input type="number" step="0.5" id="slot-input-pum" class="slots-input" value="1.5">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Школа / Ліцей (год)</label>
                                            <input type="number" step="0.5" id="slot-input-school" class="slots-input" value="4.5">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Доставка (год)</label>
                                            <input type="number" step="0.5" id="slot-input-delivery-hours" class="slots-input" value="4.0">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Заробіток доставки (грн)</label>
                                            <input type="number" step="10" id="slot-input-delivery-earnings" class="slots-input" placeholder="наприклад 880">
                                        </div>
                                        <div class="slots-form-group">
                                            <label>Примітки (необов'язково)</label>
                                            <input type="text" id="slot-input-notes" class="slots-input" placeholder="педрада, дощ тощо">
                                        </div>
                                    </div>
                                    <div class="slots-form-row-check">
                                        <label class="slots-checkbox-label">
                                            <input type="checkbox" id="slot-input-sleep" checked>
                                            <span>Залізне вікно сну (00:00 – 09:00) дотримано</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="slots-modal-footer">
                                    <button class="btn btn-secondary" onclick="closeSlotsReportModal()">Скасувати</button>
                                    <button class="btn btn-primary" onclick="saveSlotsDailyReport();closeSlotsReportModal();">
                                        <i class="ri-save-line"></i> Зберегти звіт
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Modal: History Table -->
                        <div class="slots-modal-overlay" id="slots-history-modal" style="display:none;">
                            <div class="slots-modal-card slots-modal-card-lg">
                                <div class="slots-modal-header">
                                    <div class="slots-modal-title">
                                        <i class="ri-history-line" style="color:var(--brand-primary,#3b82f6)"></i>
                                        <h3>Історія виконання слотів (останні 14 днів)</h3>
                                    </div>
                                    <button class="slots-modal-close" onclick="closeSlotsHistoryModal()"><i class="ri-close-line"></i></button>
                                </div>
                                <div class="slots-modal-body" style="overflow-x:auto;">
                                    <table class="slots-table">
                                        <thead>
                                            <tr>
                                                <th>Дата</th>
                                                <th>ПУМ</th>
                                                <th>Школа</th>
                                                <th>Доставка</th>
                                                <th>Заробіток</th>
                                                <th>Рейт</th>
                                                <th>Сон</th>
                                            </tr>
                                        </thead>
                                        <tbody id="slots-history-tbody">
                                            <tr><td colspan="7" style="text-align:center;padding:20px;">Завантаження історії...</td></tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="slots-modal-footer">
                                    <button class="btn btn-secondary" onclick="closeSlotsHistoryModal()">Закрити</button>
                                </div>
                            </div>
                        </div>

                        <!-- Modal: Slots Settings (Plan Numbers) -->
                        <div class="slots-modal-overlay" id="slots-settings-modal" style="display:none;">
                            <div class="slots-modal-card">
                                <div class="slots-modal-header">
                                    <div class="slots-modal-title">
                                        <i class="ri-settings-4-line" style="color:var(--brand-primary,#3b82f6)"></i>
                                        <h3>Налаштування планів доходів</h3>
                                    </div>
                                    <button class="slots-modal-close" onclick="closeSlotsSettingsModal()"><i class="ri-close-line"></i></button>
                                </div>
                                <div class="slots-modal-body">
                                    <div class="slots-form-grid">
                                        <div class="slots-form-group">
                                            <label><i class="ri-book-read-line" style="color:#f59e0b"></i> План Ліцей (грн/міс)</label>
                                            <input type="number" step="100" id="slots-setting-school" class="slots-input" placeholder="15500">
                                        </div>
                                        <div class="slots-form-group">
                                            <label><i class="ri-macbook-line" style="color:#0ea5e9"></i> План ПУМ (грн/міс)</label>
                                            <input type="number" step="100" id="slots-setting-pum" class="slots-input" placeholder="6000">
                                        </div>
                                        <div class="slots-form-group">
                                            <label><i class="ri-riding-line" style="color:#f97316"></i> План Доставка (грн/міс)</label>
                                            <input type="number" step="100" id="slots-setting-delivery" class="slots-input" placeholder="23500">
                                        </div>
                                        <div class="slots-form-group">
                                            <label><i class="ri-flag-2-line" style="color:#10b981"></i> Загальна планка цілі (грн) <span id="slots-target-usd-hint" style="opacity:0.75;font-weight:normal;font-size:11px;margin-left:4px;"></span></label>
                                            <input type="number" step="100" id="slots-setting-target" class="slots-input" placeholder="45000">
                                        </div>
                                    </div>
                                    <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;background:rgba(16,185,129,0.08);border:1px solid rgba(16,185,129,0.2);border-radius:8px;padding:8px 12px;font-size:12px;margin-bottom:10px;">
                                        <span style="color:#e4e4e7;"><i class="ri-flag-2-fill" style="color:#10b981;margin-right:4px;"></i> Стратегічний орієнтир: <strong style="color:#10b981;">$1 000</strong> <span id="slots-milestone-uah-hint" style="opacity:0.75;">(~41 500 грн)</span></span>
                                        <button type="button" class="btn btn-secondary" onclick="window.setSlotsTargetTo1000 && window.setSlotsTargetTo1000()" style="font-size:11px;padding:3px 8px;border-radius:6px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);color:#fff;cursor:pointer;white-space:nowrap;">Поставити $1 000</button>
                                    </div>
                                    <div style="font-size:12px;color:var(--text-muted,#a1a1aa);line-height:1.45;background:rgba(255,255,255,0.03);padding:10px 12px;border-radius:8px;border:1px solid rgba(255,255,255,0.06);">
                                        <i class="ri-information-line" style="color:var(--brand-primary,#3b82f6);margin-right:4px;"></i>
                                        Зміна планів автоматично оновить підказки <code>(план ~...к)</code> у блоці «Планка місяця» та перерахує загальний прогрес.
                                    </div>
                                </div>
                                <div class="slots-modal-footer">
                                    <button class="btn btn-secondary" onclick="closeSlotsSettingsModal()">Скасувати</button>
                                    <button class="btn btn-primary" onclick="saveSlotsSettings()">
                                        <i class="ri-save-line"></i> Зберегти плани
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="dashboard-bottom-spacer"></div>
                    </div>

                    <div class="tab-panel" id="tasks">
<div class="tab-panel-header">
                                                        <button class="sub-tab-button active" data-sub-tab="tasks-list">
                                <i class="ri-checkbox-circle-line sub-tab-icon"></i>
                                <span>Активні завдання</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="today-tasks">
                                <i class="ri-calendar-event-line sub-tab-icon"></i>
                                <span>Сьогодні</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="active-tasks">
                                <i class="ri-timer-line sub-tab-icon"></i>
                                <span>У процесі</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="no-date-tasks">
                                <i class="ri-calendar-close-line sub-tab-icon"></i>
                                <span>Без дати</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="tasks-archive">
                                <i class="ri-archive-line sub-tab-icon"></i>
                                <span>Архів</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="tasks-all">
                                <i class="ri-list-unordered sub-tab-icon"></i>
                                <span>Всі завдання</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="tasks-calendar">
                                <i class="ri-calendar-line sub-tab-icon"></i>
                                <span>Календар</span>
                            </button>

                            <div class="tab-header-right">
                                <button class="tasks-smart-sort-toggle" id="tasks-smart-sort-toggle" type="button"
                                    aria-pressed="false" title="Прострочені → Сьогодні → Решта">
                                    <i class="ri-magic-line"></i>
                                    <span>Розумне сортування</span>
                                </button>

                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>

                                <div class="data-table-bulk-actions" style="display: none;">
                                    <div class="task-bulk-more">
                                        <button class="task-bulk-more-toggle" type="button"
                                            aria-label="Масові дії для вибраних">
                                            <i class="ri-settings-4-line"></i>
                                            <span>Масові дії</span>
                                            <i class="ri-arrow-down-s-line"></i>
                                        </button>
                                        <div class="task-bulk-more-menu">
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="category"
                                                aria-label="Змінити категорію для вибраних">
                                                <i class="ri-price-tag-3-line"></i>
                                                <span>Категорія</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="date"
                                                aria-label="Змінити дату для вибраних">
                                                <i class="ri-calendar-line"></i>
                                                <span>Дата</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="period"
                                                aria-label="Змінити період для вибраних">
                                                <i class="ri-time-line"></i>
                                                <span>Період</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="limit"
                                                aria-label="Змінити ліміт для вибраних">
                                                <i class="ri-timer-line"></i>
                                                <span>Ліміт</span>
                                            </button>
                                            <button class="task-bulk-action-btn" type="button" data-task-bulk="archive"
                                                aria-label="Архівувати вибрані">
                                                <i class="ri-archive-line"></i>
                                                <span>Архів</span>
                                            </button>
                                        </div>
                                    </div>
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>

                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <!-- Add/Edit form replaced by modals at the bottom of the body -->
                        <div class="sub-tab-content">
                            <!-- Helper for repeated tables -->
                            <div class="sub-tab-panel active" id="tasks-list-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="tasks-archive-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="tasks-archive-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="active-tasks-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="active-tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="today-tasks-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="today-tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="no-date-tasks-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="no-date-tasks-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="tasks-all-content">
                                <div class="data-table-container">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-func col-checkbox"><input type="checkbox" class="select-all-checkbox">
                                                </th>
                                                <th class="col-func col-checkbox"><i class="ri-check-line"></i></th>
                                                <th class="col-timer"><i class="ri-timer-line"></i></th>
                                                <th class="sortable col-name" data-sort="title">Завдання</th>
                                                <th class="sortable col-category" data-sort="category">Категорія</th>
                                                <th class="col-period">Період</th>
                                                <th class="col-limit">Обмеження</th>
                                                <th class="sortable col-date" data-sort="due_date">Дата</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="tasks-all-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="sub-tab-panel" id="tasks-calendar-content">
                                <h3 id="calendar-month-label"
                                    style="text-align: center; color: var(--text-title); margin-bottom: 20px;"></h3>
                                <div class="kanban-container" id="tasks-calendar-grid">
                                    <!-- Calendar Grid generated by JS -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="projects">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="projects-active">
                                <i class="ri-list-check sub-tab-icon"></i>
                                <span>Активні проекти</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>

                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="projects-active-content">
                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-drag-handle"></th>
                                                <th class="col-checkbox"><input type="checkbox" class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="name">
                                                    <span class="th-label">Назва</span>
                                                </th>
                                                <th class="col-progress sortable" data-sort="progress">
                                                    <span class="th-label">Прогрес</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-shopping">
                                                    <span class="th-label">Чекліст</span>
                                                </th>
                                                <th class="col-date sortable" data-sort="created_at">
                                                    <span class="th-label">Дата</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="projects-active-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="settings">
                        <div class="tab-panel-header">
                            <div class="tab-header-right"></div>
                        </div>
                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="settings-main-content">
                                <div class="tab-panel-table">
                                    <div class="settings-card-header">
                                        <div class="settings-card-title">
                                            <i class="ri-settings-4-line"></i>
                                            <span>Системні налаштування</span>
                                        </div>
                                    </div>
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-name">Параметр</th>
                                                <th class="col-value">Значення</th>
                                                <th class="col-date">Оновлено</th>
                                            </tr>
                                        </thead>
                                        <tbody id="settings-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="statistics">
<div class="tab-panel-header">
                            <button class="sub-tab-button active" data-sub-tab="stats-general">
                                <i class="ri-dashboard-3-line sub-tab-icon"></i>
                                <span>Загальне</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="stats-training">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Тренування</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="statistics-period-switch" id="statistics-period-switch">
                                    <button class="stats-period-btn active" data-period="7d">7 днів</button>
                                    <button class="stats-period-btn" data-period="30d">30 днів</button>
                                    <button class="stats-period-btn" data-period="12m">12 міс</button>
                                    <button class="stats-period-btn" data-period="year">Рік</button>
                                    <button class="stats-period-btn" data-period="all">All</button>
                                </div>
                                <button class="stats-refresh-btn" id="statistics-refresh-btn" title="Оновити статистику">
                                    <i class="ri-refresh-line"></i>
                                    <span>Оновити</span>
                                </button>
                            </div>
                    </div>
                        <div class="statistics-dashboard" id="statistics-dashboard">
                            <!-- Підвкладка: Загальне -->
                            <div class="sub-tab-panel active" id="stats-general-content">
                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">KPI</h3>
                                    <div class="statistics-kpi-grid">
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Доходи</div>
                                            <div class="stats-kpi-value" id="stats-kpi-incomes">0.00 ₴</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Витрати</div>
                                            <div class="stats-kpi-value" id="stats-kpi-expenses">0.00 ₴</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Чистий баланс</div>
                                            <div class="stats-kpi-value" id="stats-kpi-net">0.00 ₴</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Задачі виконано</div>
                                            <div class="stats-kpi-value" id="stats-kpi-tasks">0 / 0</div>
                                        </article>
                                        <article class="stats-kpi-card">
                                            <div class="stats-kpi-label">Тренування</div>
                                            <div class="stats-kpi-value" id="stats-kpi-training">0</div>
                                        </article>
                                    </div>
                                </section>

                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">Аналітика та Цілі</h3>
                                    <div class="statistics-charts-grid stats-analytics-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Доходи vs витрати</h4>
                                            <div class="stats-chart-body" id="stats-chart-cashflow"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Витрати по категоріях</h4>
                                            <div class="stats-chart-body" id="stats-chart-expenses-categories"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Цілі: середній прогрес</h4>
                                            <div class="stats-big-percent" id="stats-goals-avg-progress">0%</div>
                                            <div class="stats-list" id="stats-goals-risk-list"></div>
                                        </article>
                                    </div>
                                </section>
                            </div>

                            <!-- Підвкладка: Тренування -->
                            <div class="sub-tab-panel" id="stats-training-content">
                                <section class="statistics-section">
                                    <h3 class="statistics-section-title">Тренування та Продуктивність</h3>
                                    <div class="statistics-charts-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Тренування: сесії та тривалість</h4>
                                            <div class="stats-chart-body" id="stats-chart-training"></div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <div class="stats-card-head">
                                                <h4 class="stats-chart-title">Прогресія тренувань (мотивація)</h4>
                                                <div class="stats-mini-switch" id="stats-training-progression-switch">
                                                    <button class="stats-mini-btn active" data-scale="month">Місяць</button>
                                                    <button class="stats-mini-btn" data-scale="year">Рік</button>
                                                </div>
                                            </div>
                                            <div class="stats-chart-body" id="stats-chart-training-progression"></div>
                                        </article>
                                    </div>
                                    <div class="statistics-secondary-grid">
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">План vs факт по таймерах задач</h4>
                                            <div class="stats-metric-inline">
                                                <span>План:</span>
                                                <strong id="stats-plan-minutes">0 хв</strong>
                                            </div>
                                            <div class="stats-metric-inline">
                                                <span>Факт:</span>
                                                <strong id="stats-fact-minutes">0 хв</strong>
                                            </div>
                                            <div class="stats-progress-wrap">
                                                <div class="stats-progress-bar" id="stats-plan-fact-progress"></div>
                                            </div>
                                        </article>
                                        <article class="stats-chart-card">
                                            <h4 class="stats-chart-title">Виконані задачі по днях тижня</h4>
                                            <div class="stats-chart-body" id="stats-chart-tasks-weekday"></div>
                                        </article>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="finances">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="bank">
                                <i class="ri-bank-line sub-tab-icon"></i>
                                <span>Рахунки</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="incomes">
                                <i class="ri-add-circle-line sub-tab-icon"></i>
                                <span>Доходи</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="expenses">
                                <i class="ri-wallet-3-line sub-tab-icon"></i>
                                <span>Витрати</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>

                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="bank-content">
                                <div class="add-bank-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Новий рахунок</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-name">Назва</label>
                                                <input type="text" id="bank-name" placeholder="Назва рахунку..."
                                                    maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-balance">Баланс</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="bank-balance" class="field-input field-input-number" placeholder="0.00" step="0.01" data-step="100">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn" data-step-target="bank-balance" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                                        <button type="button" class="field-number-btn" data-step-target="bank-balance" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-currency">Валюта</label>
                                                <input type="text" id="bank-currency" placeholder="UAH" maxlength="10"
                                                    value="UAH">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="bank-description">Опис</label>
                                                <input type="text" id="bank-description" placeholder="Опис..."
                                                    maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Зберегти" onclick="saveBank()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelBankPanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="edit-bank-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Редагування рахунку</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-name">Назва</label>
                                                <input type="text" id="edit-bank-name" placeholder="Назва рахунку..."
                                                    maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-balance">Баланс</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="edit-bank-balance" class="field-input field-input-number" placeholder="0.00" step="0.01" data-step="100">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn" data-step-target="edit-bank-balance" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                                        <button type="button" class="field-number-btn" data-step-target="edit-bank-balance" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-currency">Валюта</label>
                                                <input type="text" id="edit-bank-currency" placeholder="UAH"
                                                    maxlength="10">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-bank-description">Опис</label>
                                                <input type="text" id="edit-bank-description" placeholder="Опис..."
                                                    maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Зберегти" onclick="updateBank()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelEditBankPanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-name sortable" data-sort="name">
                                                    <span class="th-label">Назва</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-balance sortable" data-sort="balance">
                                                    <span class="th-label">Баланс</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-currency">Валюта</th>
                                                <th class="col-description">Опис</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="bank-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="sub-tab-panel" id="incomes-content">
                                <div class="add-income-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Новий дохід</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-source">Джерело</label>
                                                <input type="text" id="income-source" placeholder="Напр. Зарплата..."
                                                    maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-amount">Сума</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="income-amount" class="field-input field-input-number" placeholder="0.00" step="0.01" data-step="100">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn" data-step-target="income-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                                        <button type="button" class="field-number-btn" data-step-target="income-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-currency">Валюта</label>
                                                <input type="text" id="income-currency" placeholder="UAH" maxlength="10"
                                                    value="UAH">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-category">Категорія</label>
                                                <input type="text" id="income-category" placeholder="Напр. Робота..."
                                                    maxlength="100">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="income-description">Опис</label>
                                                <input type="text" id="income-description"
                                                    placeholder="Додаткова інформація..." maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Зберегти" onclick="saveIncome()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelIncomePanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="edit-income-panel add-edit-project-panel legacy-modal" style="display: none;">
                                    <div class="add-edit-project-panel-header">
                                        <h3 class="add-edit-project-panel-title">Редагування доходу</h3>
                                    </div>
                                    <div class="add-edit-project-panel-content">
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-source">Джерело</label>
                                                <input type="text" id="edit-income-source"
                                                    placeholder="Напр. Зарплата..." maxlength="255">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-amount">Сума</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="edit-income-amount" class="field-input field-input-number" placeholder="0.00" step="0.01" data-step="100">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn" data-step-target="edit-income-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                                        <button type="button" class="field-number-btn" data-step-target="edit-income-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-currency">Валюта</label>
                                                <input type="text" id="edit-income-currency" placeholder="UAH"
                                                    maxlength="10">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-category">Категорія</label>
                                                <input type="text" id="edit-income-category"
                                                    placeholder="Напр. Робота..." maxlength="100">
                                            </div>
                                        </div>
                                        <div class="add-edit-project-panel-row">
                                            <div class="add-edit-project-panel-group">
                                                <label class="field-label" for="edit-income-description">Опис</label>
                                                <input type="text" id="edit-income-description"
                                                    placeholder="Додаткова інформація..." maxlength="500">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-edit-project-panel-actions">
                                        <button class="btn-save" title="Зберегти" onclick="updateIncome()">Зберегти</button>
                                        <button class="btn-cancel" title="Скасувати"
                                            onclick="cancelEditIncomePanel()">Скасувати</button>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-name sortable" data-sort="source">
                                                    <span class="th-label">Джерело</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-amount sortable" data-sort="amount">
                                                    <span class="th-label">Сума</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-currency">Валюта</th>
                                                <th class="col-category">Категорія</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="incomes-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="sub-tab-panel" id="expenses-content">
                                <!-- Budget Status Widget -->
                                <div class="budget-status-card" style="background: var(--bg-surface); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg); padding: 16px 20px; margin-bottom: 16px; display: flex; flex-direction: column; gap: 14px;">
                                    <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
                                        <div style="display: flex; align-items: center; gap: 14px;">
                                            <div style="width: 42px; height: 42px; border-radius: 10px; background: rgba(59, 130, 246, 0.15); color: #3b82f6; display: flex; align-items: center; justify-content: center; font-size: 20px;">
                                                <i class="ri-pie-chart-2-line"></i>
                                            </div>
                                            <div>
                                                <div style="font-size: 14px; font-weight: 600; color: var(--text-title);">Місячний бюджет витрат</div>
                                                <div style="font-size: 12px; color: var(--text-muted); margin-top: 2px;">
                                                    Загалом витрачено: <strong id="budget-spent-amount" style="color: var(--text-title);">0 ₴</strong> з <span id="budget-total-limit">15,000 ₴</span>
                                                    <span id="budget-remaining-text" style="margin-left: 6px; color: var(--text-dim);">(залишок: 15,000 ₴)</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="display: flex; align-items: center; gap: 8px;">
                                            <span style="font-size: 12px; color: var(--text-dim);">Загальне використання:</span>
                                            <span id="budget-percentage-text" style="font-size: 13px; font-weight: 600; color: #10b981;">0%</span>
                                        </div>
                                    </div>

                                    <!-- Дві категорії лімітів -->
                                    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 14px; padding-top: 12px; border-top: 1px solid rgba(255,255,255,0.06);">
                                        <!-- Ліміт 1: Розходи на місяць -->
                                        <div style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: var(--radius-md); padding: 12px 14px;">
                                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                                                <span style="font-size: 13px; font-weight: 500; color: var(--text-title); display: flex; align-items: center; gap: 6px;">
                                                    <i class="ri-shopping-bag-3-line" style="color: #3b82f6;"></i> Розходи (поточні)
                                                </span>
                                                <span id="budget-daily-pct" style="font-size: 12px; font-weight: 600; color: #10b981;">0%</span>
                                            </div>
                                            <div style="height: 7px; background: rgba(255,255,255,0.08); border-radius: 4px; overflow: hidden; margin-bottom: 6px;">
                                                <div id="budget-daily-bar" style="width: 0%; height: 100%; background: #10b981; transition: width 0.4s ease, background 0.3s ease;"></div>
                                            </div>
                                            <div style="display: flex; justify-content: space-between; font-size: 12px; color: var(--text-muted);">
                                                <span>Витрачено: <strong id="budget-daily-spent" style="color: var(--text-title);">0 ₴</strong></span>
                                                <span>Ліміт: <strong>7,500 ₴</strong></span>
                                            </div>
                                        </div>

                                        <!-- Ліміт 2: Квартира + Комуналка + Інтернет -->
                                        <div style="background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: var(--radius-md); padding: 12px 14px;">
                                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                                                <span style="font-size: 13px; font-weight: 500; color: var(--text-title); display: flex; align-items: center; gap: 6px;">
                                                    <i class="ri-home-4-line" style="color: #8b5cf6;"></i> Квартира + комуналка + інтернет
                                                </span>
                                                <span id="budget-housing-pct" style="font-size: 12px; font-weight: 600; color: #10b981;">0%</span>
                                            </div>
                                            <div style="height: 7px; background: rgba(255,255,255,0.08); border-radius: 4px; overflow: hidden; margin-bottom: 6px;">
                                                <div id="budget-housing-bar" style="width: 0%; height: 100%; background: #10b981; transition: width 0.4s ease, background 0.3s ease;"></div>
                                            </div>
                                            <div style="display: flex; justify-content: space-between; font-size: 12px; color: var(--text-muted);">
                                                <span>Витрачено: <strong id="budget-housing-spent" style="color: var(--text-title);">0 ₴</strong></span>
                                                <span>Ліміт: <strong>7,500 ₴</strong></span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Блок для великих / позалімітних покупок (якщо є) -->
                                    <div id="budget-extra-row" style="display: none; align-items: center; justify-content: space-between; background: rgba(139, 92, 246, 0.08); border: 1px dashed rgba(139, 92, 246, 0.3); border-radius: var(--radius-md); padding: 10px 14px; font-size: 12.5px;">
                                        <span style="color: #c4b5fd; display: flex; align-items: center; gap: 8px;">
                                            <i class="ri-vip-diamond-line" style="color: #a78bfa; font-size: 15px;"></i>
                                            <span><strong>Великі покупки (поза лімітом):</strong> не входять у щомісячні 15 000 ₴</span>
                                        </span>
                                        <strong id="budget-extra-spent" style="color: #e9d5ff; font-size: 13px;">0 ₴</strong>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-date sortable" data-sort="date">
                                                    <span class="th-label">Дата</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-category sortable" data-sort="expense_type">
                                                    <span class="th-label">Тип витрати</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-name"><span class="th-label">Магазин</span></th>
                                                <th class="col-amount sortable" data-sort="amount">
                                                    <span class="th-label">Сума</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-currency">Валюта</th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="expenses-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ===== ВКЛАДКА ТРЕНУВАННЯ ===== -->
                    <div class="tab-panel" id="training">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="running">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Біг</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="pullups">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Підтягування</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="pushups">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Віджимання</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="training-history">
                                <i class="ri-run-line sub-tab-icon"></i>
                                <span>Історія</span>
                            </button>
                            <div class="tab-header-right">
                                <button class="btn btn-secondary btn-sm" id="btn-workout-preset" style="display: inline-flex; align-items: center; gap: 6px;">
                                    <i class="ri-flashlight-line"></i> Шаблон тренування
                                </button>
                            </div>
                    </div>


                        <div class="sub-tab-content">
                    <!-- Підвкладка: Біг -->
                    <div class="sub-tab-panel active" id="running-content">
                        <div class="training-section">
                            <div class="training-info">
                                <div class="training-week">
                                    <span class="training-label">Тиждень:</span>
                                    <span class="training-value" id="training-current-week">1</span>
                                </div>
                                <div class="training-duration">
                                    <span class="training-label">Час бігу:</span>
                                    <span class="training-value" id="training-run-duration">20 хв</span>
                                </div>
                            </div>
                            <div class="training-plan-card">
                                <div class="training-plan-title">План бігу</div>
                                <div class="training-plan-note" id="running-plan-note">Базово 20 хв, +1 хв щотижня</div>
                                <div class="training-week-status" id="running-week-status"></div>
                            </div>

                            <div class="training-timer">
                                <div class="timer-display" id="run-timer-display">00:00:00</div>
                                <div class="timer-controls">
                                    <button class="btn-timer btn-start" id="run-timer-start" onclick="startRunTimer()">
                                        <span>▶</span> Старт
                                    </button>
                                    <button class="btn-timer btn-pause" id="run-timer-pause" onclick="pauseRunTimer()"
                                        style="display: none;">
                                        <span>⏸</span> Пауза
                                    </button>
                                    <button class="btn-timer btn-resume" id="run-timer-resume"
                                        onclick="resumeRunTimer()" style="display: none;">
                                        <span>▶</span> Продовжити
                                    </button>
                                    <button class="btn-timer btn-stop" id="run-timer-stop" onclick="stopRunTimer()"
                                        style="display: none;">
                                        <span>⏹</span> Завершити
                                    </button>
                                </div>
                            </div>

                            <div class="training-today-sessions" id="running-today-sessions">
                                <!-- Сесії бігу за сьогодні -->
                            </div>
                        </div>
                    </div>

                    <!-- Підвкладка: Підтягування -->
                    <div class="sub-tab-panel" id="pullups-content">
                        <div class="training-section">
                            <div class="training-plan-card">
                                <div class="training-plan-title">План підтягувань (5 підходів)</div>
                                <div class="training-plan-sets" id="pullups-plan-sets"></div>
                                <div class="training-plan-note" id="pullups-plan-note"></div>
                                <div class="training-plan-progress" id="pullups-plan-progress"></div>
                                <div class="training-week-status" id="pullups-week-status"></div>
                            </div>
                            <div class="training-sets-form">
                                <h3 class="training-form-title">Новий підхід</h3>
                                <div class="training-form-row">
                                    <div class="training-form-group">
                                        <label class="field-label" for="pullups-reps">Кількість повторів</label>
                                        <input type="number" id="pullups-reps" min="1" max="100" placeholder="0">
                                    </div>
                                    <button class="btn-add-set" onclick="addSet('pullups')">+ Додати підхід</button>
                                    <button class="btn-add-set btn-add-set-plan" onclick="addNextPlannedSet('pullups')">+ Додати за планом</button>
                                </div>
                            </div>

                            <div class="training-current-session" id="pullups-current-session">
                                <h3 class="training-form-title">Поточна сесія</h3>
                                <div class="training-sets-list" id="pullups-sets-list">
                                    <!-- Підходи поточної сесії -->
                                </div>
                                <div class="training-session-actions" id="pullups-session-actions"
                                    style="display: none;">
                                    <button class="btn-timer btn-stop" onclick="finishSession('pullups')">
                                        <span>✓</span> Завершити тренування
                                    </button>
                                </div>
                            </div>

                            <div class="training-today-sessions" id="pullups-today-sessions">
                                <!-- Сесії за сьогодні -->
                            </div>
                        </div>
                    </div>

                    <!-- Підвкладка: Віджимання -->
                    <div class="sub-tab-panel" id="pushups-content">
                        <div class="training-section">
                            <div class="training-plan-card">
                                <div class="training-plan-title">План віджимань (5 підходів)</div>
                                <div class="training-plan-sets" id="pushups-plan-sets"></div>
                                <div class="training-plan-note" id="pushups-plan-note"></div>
                                <div class="training-plan-progress" id="pushups-plan-progress"></div>
                                <div class="training-week-status" id="pushups-week-status"></div>
                            </div>
                            <div class="training-sets-form">
                                <h3 class="training-form-title">Новий підхід</h3>
                                <div class="training-form-row">
                                    <div class="training-form-group">
                                        <label class="field-label" for="pushups-reps">Кількість повторів</label>
                                        <input type="number" id="pushups-reps" min="1" max="100" placeholder="0">
                                    </div>
                                    <button class="btn-add-set" onclick="addSet('pushups')">+ Додати підхід</button>
                                    <button class="btn-add-set btn-add-set-plan" onclick="addNextPlannedSet('pushups')">+ Додати за планом</button>
                                </div>
                            </div>

                            <div class="training-current-session" id="pushups-current-session">
                                <h3 class="training-form-title">Поточна сесія</h3>
                                <div class="training-sets-list" id="pushups-sets-list">
                                    <!-- Підходи поточної сесії -->
                                </div>
                                <div class="training-session-actions" id="pushups-session-actions"
                                    style="display: none;">
                                    <button class="btn-timer btn-stop" onclick="finishSession('pushups')">
                                        <span>✓</span> Завершити тренування
                                    </button>
                                </div>
                            </div>

                            <div class="training-today-sessions" id="pushups-today-sessions">
                                <!-- Сесії за сьогодні -->
                            </div>
                        </div>
                    </div>

                    <!-- Підвкладка: Історія -->
                    <div class="sub-tab-panel" id="training-history-content">
                        <div class="training-section">
                            <div class="training-history-filters">
                                <button class="filter-button active" data-filter="all"
                                    onclick="filterTrainingHistory('all')">Всі</button>
                                <button class="filter-button" data-filter="running"
                                    onclick="filterTrainingHistory('running')">Біг</button>
                                <button class="filter-button" data-filter="pullups"
                                    onclick="filterTrainingHistory('pullups')">Підтягування</button>
                                <button class="filter-button" data-filter="pushups"
                                    onclick="filterTrainingHistory('pushups')">Віджимання</button>
                            </div>

                            <div class="tab-panel-table">
                                <table class="data-table">
                                    <thead>
                                        <tr>
                                            <th class="col-date sortable" data-sort="date">
                                                <span class="th-label">Дата</span>
                                                <span class="sort-icon">↕</span>
                                            </th>
                                            <th class="col-category">
                                                <span class="th-label">Тип</span>
                                            </th>
                                            <th class="col-name">
                                                <span class="th-label">Результат</span>
                                            </th>
                                            <th class="col-actions"></th>
                                        </tr>
                                    </thead>
                                    <tbody id="training-history-tbody"></tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                        </div>
                    </div>

                    <div class="tab-panel" id="egds">
<div class="tab-panel-header">
                            <button class="sub-tab-button active" data-sub-tab="egds-products">
                                <i class="ri-store-2-line sub-tab-icon"></i>
                                <span>Товари</span>
                            </button>
                            <button class="sub-tab-button" data-sub-tab="egds-orders">
                                <i class="ri-shopping-bag-3-line sub-tab-icon"></i>
                                <span>Замовлення</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>
                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="egds-products-content">
                                <div id="egds-product-form-panel" class="custom-modal">
                                    <div class="custom-modal-content edit-modal-wide">
                                        <h3 class="custom-modal-title" id="egds-product-form-title">Новий товар</h3>
                                        <input type="hidden" id="egds-product-id">
                                        <div class="modal-form-grid">
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-name">Назва</label>
                                                <input type="text" id="egds-product-name" class="field-input"
                                                    placeholder="Назва товару..." maxlength="255">
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-category">Категорія</label>
                                                <input type="text" id="egds-product-category" class="field-input"
                                                    placeholder="Напр. Смартфони" maxlength="100">
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-price">Ціна</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="egds-product-price"
                                                        class="field-input field-input-number" placeholder="0.00"
                                                        step="0.01" min="0">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-price" data-step-dir="up"
                                                            aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-price" data-step-dir="down"
                                                            aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-product-stock">Залишок</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="egds-product-stock"
                                                        class="field-input field-input-number" placeholder="0" step="1"
                                                        min="0">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-stock" data-step-dir="up"
                                                            aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-product-stock" data-step-dir="down"
                                                            aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="custom-modal-actions">
                                            <button class="btn-secondary" onclick="cancelEgdsForms()">Скасувати</button>
                                            <button class="btn-danger"
                                                style="background: var(--text-main); color: var(--bg-app);"
                                                onclick="saveEgdsProduct()">Зберегти</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="name"><span
                                                        class="th-label">Назва</span></th>
                                                <th class="col-category sortable" data-sort="category"><span
                                                        class="th-label">Категорія</span></th>
                                                <th class="col-price sortable" data-sort="price"><span
                                                        class="th-label">Ціна</span></th>
                                                <th class="col-limit sortable" data-sort="stock_quantity"><span
                                                        class="th-label">Залишок</span></th>
                                                <th class="col-date sortable" data-sort="updated_at"><span
                                                        class="th-label">Оновлено</span></th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="egds-products-tbody"></tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="sub-tab-panel" id="egds-orders-content">
                                <div id="egds-order-form-panel" class="custom-modal">
                                    <div class="custom-modal-content edit-modal-wide">
                                        <h3 class="custom-modal-title" id="egds-order-form-title">Нове замовлення</h3>
                                        <input type="hidden" id="egds-order-id">
                                        <div class="modal-form-grid">
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-number">Номер замовлення</label>
                                                <input type="text" id="egds-order-number" class="field-input"
                                                    placeholder="ORD-2026-001" maxlength="50">
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-customer-id">Клієнт</label>
                                                <div class="field-select-wrap">
                                                    <select id="egds-order-customer-id" class="field-select"></select>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-total">Сума</label>
                                                <div class="field-number-wrap">
                                                    <input type="number" id="egds-order-total"
                                                        class="field-input field-input-number" placeholder="0.00"
                                                        step="0.01" min="0">
                                                    <div class="field-number-controls">
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-order-total" data-step-dir="up"
                                                            aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                                        <button type="button" class="field-number-btn"
                                                            data-step-target="egds-order-total" data-step-dir="down"
                                                            aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="field-label" for="egds-order-status">Статус</label>
                                                <div class="field-select-wrap">
                                                    <select id="egds-order-status" class="field-select">
                                                        <option value="new">new</option>
                                                        <option value="processing">processing</option>
                                                        <option value="shipped">shipped</option>
                                                        <option value="delivered">delivered</option>
                                                        <option value="cancelled">cancelled</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="custom-modal-actions">
                                            <button class="btn-secondary" onclick="cancelEgdsForms()">Скасувати</button>
                                            <button class="btn-danger"
                                                style="background: var(--text-main); color: var(--bg-app);"
                                                onclick="saveEgdsOrder()">Зберегти</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="order_number"><span
                                                        class="th-label">№ замовлення</span></th>
                                                <th class="col-name sortable" data-sort="customer_name"><span
                                                        class="th-label">Клієнт</span></th>
                                                <th class="col-price sortable" data-sort="total_amount"><span
                                                        class="th-label">Сума</span></th>
                                                <th class="col-category sortable" data-sort="status"><span
                                                        class="th-label">Статус</span></th>
                                                <th class="col-date sortable" data-sort="created_at"><span
                                                        class="th-label">Створено</span></th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="egds-orders-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="tab-panel" id="goals">
<div class="tab-panel-header">
                            <button class="sub-tab-button active" data-sub-tab="goals-current">
                                <i class="ri-focus-3-line sub-tab-icon"></i>
                                <span>Поточні цілі</span>
                            </button>

                            <div class="tab-header-right">
                                <div class="goals-view-switcher" id="goals-view-switcher">
                                    <button type="button" class="goals-view-btn active" data-view="grid" title="Вид картками">
                                        <i class="ri-grid-fill"></i> <span>Картки</span>
                                    </button>
                                    <button type="button" class="goals-view-btn" data-view="table" title="Вид таблицею">
                                        <i class="ri-table-line"></i> <span>Таблиця</span>
                                    </button>
                                </div>
                                <button type="button" class="goals-select-all-btn" id="goals-select-all-btn" title="Виділити всі картки">
                                    <i class="ri-checkbox-multiple-line"></i>
                                    <span>Виділити всі</span>
                                </button>
                                <div class="selected-data-table-item" style="display: none;">
                                    <i class="ri-check-line sub-tab-icon"></i>
                                    <span class="selected-data-table-item-badge">0</span>
                                    <span class="selected-data-table-item-label">вибрано</span>
                                </div>
                                <div class="data-table-bulk-actions" style="display: none;">
                                    <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити</span>
                                    </button>
                                </div>
                                <button class="add-data-table-item" data-tooltip="Гаряча клавіша: N">
                                    <i class="ri-add-line sub-tab-icon"></i>
                                    <span>Додати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="goals-current-content">
                                <div class="goals-cards-grid" id="goals-cards-grid"></div>
                                <div class="tab-panel-table" id="goals-table-container" style="display: none;">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox"></th>
                                                <th class="col-name sortable" data-sort="title"><span
                                                        class="th-label">Назва</span></th>
                                                <th class="col-category sortable" data-sort="category"><span
                                                        class="th-label">Категорія</span></th>
                                                <th class="col-status sortable" data-sort="status"><span
                                                        class="th-label">Статус</span></th>
                                                <th class="col-limit sortable" data-sort="progress_percent"><span
                                                        class="th-label">Прогрес</span></th>
                                                <th class="col-date sortable" data-sort="target_at"><span
                                                        class="th-label">Дедлайн</span></th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="goals-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="youtube">
<div class="tab-panel-header">

                            <button class="sub-tab-button active" data-sub-tab="fancy-music">
                                <i class="ri-youtube-line sub-tab-icon"></i>
                                <span>Fancy Music</span>
                            </button>
                            <div class="tab-header-right">
                                <button class="stats-refresh-btn" id="youtube-sync-btn" title="Синхронізувати з YouTube">
                                    <i class="ri-refresh-line"></i>
                                    <span>Синхронізувати</span>
                                </button>
                            </div>
                    </div>

                        <div class="sub-tab-content">
                            <div class="sub-tab-panel active" id="fancy-music-content">
                                <div class="tab-panel-table">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="col-checkbox"><input type="checkbox"
                                                        class="select-all-checkbox">
                                                </th>
                                                <th class="col-name sortable" data-sort="title">
                                                    <span class="th-label">Назва</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-type sortable" data-sort="video_type">
                                                    <span class="th-label">Тип</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-date sortable" data-sort="published_at">
                                                    <span class="th-label">Дата публікації</span>
                                                    <span class="sort-icon">↕</span>
                                                </th>
                                                <th class="col-actions"></th>
                                            </tr>
                                        </thead>
                                        <tbody id="fancy-music-table-tbody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="profile">
<div class="tab-panel-header">
                            <div class="tab-header-right"></div>
                    </div>

                        <div class="profile-content">
                            <input type="file" id="avatar-upload-input" style="display: none;" accept="image/*">
                            
                            <div class="profile-card-compact">
                                <div class="profile-compact-left">
                                    <div class="profile-avatar" id="profile-avatar-container" aria-label="Фото профілю"
                                        onclick="document.getElementById('avatar-upload-input').click()" title="Натисніть для зміни фото">
                                        <img src="data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 64 64%22%3E%3Crect width=%2264%22 height=%2264%22 rx=%2232%22 fill=%22%231e293b%22/%3E%3Cpath d=%22M32 34c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm0 5c-6.08 0-18 3.06-18 9.15V52h36v-3.85c0-6.09-11.92-9.15-18-9.15z%22 fill=%22%2394a3b8%22/%3E%3C/svg%3E" alt="avatar" id="profile-avatar-img" onerror="this.onerror=null; this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 64 64%22%3E%3Crect width=%2264%22 height=%2264%22 rx=%2232%22 fill=%22%231e293b%22/%3E%3Cpath d=%22M32 34c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm0 5c-6.08 0-18 3.06-18 9.15V52h36v-3.85c0-6.09-11.92-9.15-18-9.15z%22 fill=%22%2394a3b8%22/%3E%3C/svg%3E';">
                                        <div class="avatar-overlay"><i class="ri-camera-line"></i></div>
                                    </div>

                                    <div class="profile-identity">
                                        <div class="profile-name-row">
                                            <h2 class="profile-display-name" id="profile-nickname">—</h2>
                                            <span class="profile-chip">
                                                <i class="ri-user-line"></i>
                                                <span id="profile-username">—</span>
                                            </span>
                                        </div>
                                        <div class="profile-identity-meta">
                                            <span class="profile-meta-item">
                                                <i class="ri-calendar-line"></i>
                                                <span>Створено: <strong id="profile-created">—</strong></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="profile-compact-actions" id="profile-actions">
                                    <button type="button" class="profile-action-btn" onclick="document.getElementById('avatar-upload-input').click()"
                                        title="Змінити фото профілю">
                                        <i class="ri-camera-line"></i>
                                        <span>Фото</span>
                                    </button>
                                    <button type="button" class="profile-action-btn profile-action-edit" onclick="showEditProfile()"
                                        title="Редагувати профіль">
                                        <i class="ri-edit-line"></i>
                                        <span>Редагувати</span>
                                    </button>
                                    <button type="button" class="profile-action-btn profile-action-logout" onclick="handleLogout()" title="Вийти з системи">
                                        <i class="ri-logout-box-r-line"></i>
                                        <span>Вийти</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="edit-profile-panel add-edit-project-panel legacy-modal" style="display: none;">
                            <div class="add-edit-project-panel-header">
                                <h3 class="add-edit-project-panel-title">Редагування профілю</h3>
                            </div>
                            <div class="add-edit-project-panel-content">
                                <div class="add-edit-project-panel-row">
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-nickname">Нікнейм</label>
                                        <input type="text" id="edit-profile-nickname" placeholder="Як вас називати?..."
                                            maxlength="100">
                                    </div>
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-username">Логін</label>
                                        <input type="text" id="edit-profile-username"
                                            placeholder="Введіть новий логін..." maxlength="50">
                                    </div>
                                </div>
                                <div class="add-edit-project-panel-row">
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-password">Новий пароль</label>
                                        <input type="password" id="edit-profile-password"
                                            placeholder="Введіть новий пароль..." maxlength="100">
                                    </div>
                                </div>
                                <div class="add-edit-project-panel-row">
                                    <div class="add-edit-project-panel-group">
                                        <label class="field-label" for="edit-profile-confirm-password">Підтвердження
                                            пароля</label>
                                        <input type="password" id="edit-profile-confirm-password"
                                            placeholder="Повторіть новий пароль..." maxlength="100">
                                    </div>
                                </div>
                            </div>
                            <div class="add-edit-project-panel-actions">
                                <button class="btn-save" title="Зберегти" onclick="updateProfile()">Зберегти</button>
                                <button class="btn-cancel" title="Скасувати" onclick="cancelEditProfile()">Скасувати</button>
                        </div>
                        </div>
                    </div>

                    <div class="tab-panel" id="photo-reports">
<div class="tab-panel-header photo-reports-panel-header">
                            <div class="photo-reports-header-left">
                                <div class="sub-tab-button active is-static" style="cursor: default;">
                                    <i class="ri-gallery-line sub-tab-icon"></i>
                                    <span>Фотозвіти</span>
                                </div>
                            </div>
                            <div class="tab-header-right">
                                <button class="add-data-table-item" id="btn-generate-photo-report">
                                    <i class="ri-magic-line sub-tab-icon"></i>
                                    <span>Згенерувати новий звіт</span>
                                </button>
                            </div>
                    </div>

                        <div class="report-generator-box">
                            <div class="report-generator-controls">
                                <div class="report-type-selector">
                                    <span class="control-label">Обрати період:</span>
                                    <div class="segmented-control" id="report-type-segmented">
                                        <button class="segment-btn active" data-report-type="week">Тиждень</button>
                                        <button class="segment-btn" data-report-type="month">Місяць</button>
                                        <button class="segment-btn" data-report-type="year">Рік</button>
                                    </div>
                                </div>
                                <div class="report-actions-row">
                                    <button class="btn btn-secondary" id="btn-download-report-img" title="Завантажити картинку на пристрій">
                                        <i class="ri-download-2-line"></i> Завантажити PNG
                                    </button>
                                    <button class="btn btn-primary" id="btn-save-report-gallery" title="Зберегти звіт у галерею">
                                        <i class="ri-bookmark-3-line"></i> Зберегти в галерею
                                    </button>
                                </div>
                            </div>

                            <div class="report-preview-container">
                                <canvas id="photo-report-canvas" width="1200" height="675" style="display:none;"></canvas>
                                <div class="report-preview-wrapper" id="report-preview-wrapper">
                                    <img id="report-preview-img" alt="Прев'ю фотозвіту" src="">
                                    <div class="report-preview-spinner" id="report-preview-spinner">
                                        <i class="ri-loader-4-line bb-spin"></i> Генеруємо ваш підсумковий фотозвіт...
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="photo-gallery-section">
                            <div class="gallery-toolbar">
                                <div class="gallery-title">
                                    <h3><i class="ri-history-line"></i> Архів збережених фотозвітів</h3>
                                    <span class="gallery-count" id="gallery-count-badge">0 карт у галереї</span>
                                </div>
                                <div class="gallery-filter-chips" id="gallery-filter-chips">
                                    <button class="filter-chip active" data-gallery-filter="all">Усі</button>
                                    <button class="filter-chip" data-gallery-filter="week">Тижневі</button>
                                    <button class="filter-chip" data-gallery-filter="month">Місячні</button>
                                    <button class="filter-chip" data-gallery-filter="year">Річні</button>
                                </div>
                            </div>

                            <div id="photo-reports-gallery" class="photo-reports-gallery-grid">
                                <div class="dash-loading"><i class="ri-loader-4-line bb-spin"></i> Завантаження галереї...</div>
                            </div>
                        </div>
                    </div>
                <!-- База знань -->
                <div id="notes" class="tab-panel">
<div class="tab-panel-header">
                        <button class="sub-tab-button active is-static" data-sub-tab="notes-list" type="button">
                            <i class="ri-book-read-line sub-tab-icon"></i>
                            <span>Всі нотатки</span>
                        </button>

                        <div class="tab-header-right">
                            <div class="selected-data-table-item" style="display: none;">
                                <i class="ri-check-line sub-tab-icon"></i>
                                <span class="selected-data-table-item-badge">0</span>
                                <span class="selected-data-table-item-label">вибрано</span>
                            </div>

                            <div class="data-table-bulk-actions" style="display: none;">
                                <button class="delete-data-table-item" aria-label="Видалити вибрані записи">
                                    <i class="ri-delete-bin-line"></i>
                                    <span>Видалити</span>
                                </button>
                            </div>

                            <button class="add-data-table-item" id="notes-add-btn" data-tooltip="Гаряча клавіша: N">
                                <i class="ri-add-line sub-tab-icon"></i>
                                <span>Додати</span>
                            </button>
                        </div>
                    </div>

                    <div class="sub-tab-content">
                        <div class="sub-tab-panel active" id="notes-list-content">
                            <div class="notes-container" id="notes-container">
                                <!-- Sidebar -->
                                <div class="notes-sidebar" id="notes-sidebar">
                                    <div class="notes-sidebar-header">
                                        <div class="notes-search-wrapper">
                                            <i class="ri-search-line search-icon"></i>
                                            <input type="text" id="notes-search-input" placeholder="Пошук нотаток..." class="notes-search-input">
                                            <button id="notes-density-btn" class="notes-density-btn" title="Компактний вигляд (приховати прев'ю)" type="button" aria-label="Перемкнути щільність списку">
                                                <i class="ri-menu-unfold-line"></i>
                                            </button>
                                        </div>
                                        <button id="new-note-btn" class="notes-new-btn">
                                            <i class="ri-add-line"></i>
                                            <span>Створити</span>
                                        </button>
                                    </div>
                                    <div class="notes-list-wrapper">
                                        <ul id="notes-list" class="notes-list"></ul>
                                    </div>
                                </div>

                                <!-- Editor Workspace -->
                                <div class="notes-editor" id="notes-editor">
                                    <div id="notes-empty-state" class="notes-empty-state" style="display: none;">
                                        <div class="empty-state-icon"><i class="ri-draft-line"></i></div>
                                        <h3>Нотатку не обрано</h3>
                                        <p>Оберіть нотатку зі списку ліворуч або створіть нову</p>
                                        <button id="empty-new-note-btn" class="notes-new-btn">
                                            <i class="ri-add-line"></i> Створити нотатку
                                        </button>
                                    </div>

                                    <div id="notes-editor-inner" class="notes-editor-inner">
                                        <div class="notes-editor-toolbar">
                                            <button type="button" id="notes-back-btn" class="notes-btn-back" title="Назад до списку нотаток" aria-label="Назад до списку">
                                                <i class="ri-arrow-left-s-line"></i>
                                                <span>Нотатки</span>
                                            </button>
                                            <div class="notes-meta-info">
                                                <span id="note-save-status" class="note-save-status"><i class="ri-checkbox-circle-line"></i> Автозбережено</span>
                                            </div>
                                            <div class="notes-actions">
                                                <input type="file" id="note-image-file-input" accept="image/png,image/jpeg,image/gif,image/webp" style="display: none;">
                                                <button type="button" id="pin-note-btn" class="notes-btn-action notes-btn-pin" title="Закріпити нотатку">
                                                    <i class="ri-pushpin-line"></i>
                                                    <span class="btn-text">Закріпити</span>
                                                </button>
                                                <button type="button" id="delete-note-btn" class="notes-btn-action btn-danger" title="Видалити">
                                                    <i class="ri-delete-bin-line"></i>
                                                </button>
                                                <button type="button" id="save-note-btn" class="notes-btn-action btn-primary is-saved" title="Зберегти (Ctrl+S)">
                                                    <i class="ri-save-line"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="notes-editor-canvas" id="notes-editor-canvas">
                                            <div id="notes-document" class="notes-document" contenteditable="true" spellcheck="true">
                                                <h1 id="note-title" class="note-title-input" data-placeholder="Заголовок нотатки..."></h1>
                                                <div id="note-content" class="note-content-editor" data-placeholder="Почніть вводити текст нотатки..."></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Контекстне меню форматування ПКМ -->
                                <div id="notes-context-menu" class="notes-context-menu" style="display: none;">
                                    <button type="button" class="notes-menu-item" data-action="pin" id="notes-menu-pin">
                                        <i class="ri-pushpin-line"></i>
                                        <span id="notes-menu-pin-label">Закріпити нотатку</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="duplicate" id="notes-menu-duplicate">
                                        <i class="ri-file-copy-line"></i>
                                        <span>Дублювати нотатку</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="copy-content" id="notes-menu-copy-content">
                                        <i class="ri-clipboard-line"></i>
                                        <span>Скопіювати текст</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="move-up" id="notes-menu-move-up">
                                        <i class="ri-arrow-up-line"></i>
                                        <span>Перемістити вище</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="move-down" id="notes-menu-move-down">
                                        <i class="ri-arrow-down-line"></i>
                                        <span>Перемістити нижче</span>
                                    </button>
                                    <div class="notes-menu-divider" id="notes-menu-editor-divider"></div>
                                    <button type="button" class="notes-menu-item" data-action="insert-photo" id="notes-menu-insert-photo">
                                        <i class="ri-image-add-line"></i>
                                        <span>Вставити фото</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="copy-image" id="notes-menu-copy-image" style="display: none;">
                                        <i class="ri-file-copy-line"></i>
                                        <span>Копіювати фото</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="copy-image-url" id="notes-menu-copy-image-url" style="display: none;">
                                        <i class="ri-link"></i>
                                        <span>Копіювати посилання на фото</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="view-image" id="notes-menu-view-image" style="display: none;">
                                        <i class="ri-fullscreen-line"></i>
                                        <span>Переглянути в повному розмірі</span>
                                    </button>
                                    <button type="button" class="notes-menu-item text-danger" data-action="delete-image" id="notes-menu-delete-image" style="display: none;">
                                        <i class="ri-delete-bin-line"></i>
                                        <span>Видалити фото</span>
                                    </button>
                                    <div class="notes-menu-divider" id="notes-menu-format-divider"></div>
                                    <button type="button" class="notes-menu-item" data-action="highlight" id="notes-menu-highlight">
                                        <i class="ri-mark-pen-line"></i>
                                        <span>Виділити сірим</span>
                                        <span class="notes-menu-shortcut">Ctrl+H</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="italic">
                                        <i class="ri-italic"></i>
                                        <span>Курсив</span>
                                        <span class="notes-menu-shortcut">Ctrl+I</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="bold">
                                        <i class="ri-bold"></i>
                                        <span>Жирний</span>
                                        <span class="notes-menu-shortcut">Ctrl+B</span>
                                    </button>
                                    <div class="notes-menu-divider"></div>
                                    <button type="button" class="notes-menu-item" data-action="link">
                                        <i class="ri-link"></i>
                                        <span id="notes-menu-link-label">Вставити посилання</span>
                                        <span class="notes-menu-shortcut">Ctrl+K</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="open-link" id="notes-menu-open-link" style="display: none;">
                                        <i class="ri-external-link-line"></i>
                                        <span>Перейти за посиланням</span>
                                    </button>
                                    <button type="button" class="notes-menu-item" data-action="unlink" id="notes-menu-unlink" style="display: none;">
                                        <i class="ri-link-unlink-m"></i>
                                        <span>Видалити посилання</span>
                                    </button>
                                    <div class="notes-menu-divider"></div>
                                    <button type="button" class="notes-menu-item" data-action="clear">
                                        <i class="ri-format-clear"></i>
                                        <span>Очистити форматування</span>
                                    </button>
                                </div>

                                <!-- Модальне вікно для вставки / редагування посилання -->
                                <div id="note-link-modal-overlay" class="note-link-modal-overlay" style="display: none;">
                                    <div class="note-link-modal">
                                        <div class="note-link-modal-header">
                                            <span class="note-link-modal-title" id="note-link-modal-title"><i class="ri-link"></i> <span>Вставити посилання</span></span>
                                            <button type="button" class="note-link-modal-close" id="note-link-modal-close"><i class="ri-close-line"></i></button>
                                        </div>
                                        <div class="note-link-modal-body">
                                            <div class="note-link-field">
                                                <label for="note-link-text-input">Текст посилання</label>
                                                <input type="text" id="note-link-text-input" placeholder="Відображуваний текст..." autocomplete="off">
                                            </div>
                                            <div class="note-link-field">
                                                <label for="note-link-url-input">Посилання (URL)</label>
                                                <input type="text" id="note-link-url-input" placeholder="https://example.com" autocomplete="off">
                                            </div>
                                        </div>
                                        <div class="note-link-modal-footer">
                                            <button type="button" class="notes-btn-action" id="note-link-cancel-btn">Скасувати</button>
                                            <button type="button" class="notes-btn-action btn-primary" id="note-link-save-btn">Застосувати</button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Модальне вікно для повнорозмірного перегляду фото -->
                                <div id="note-image-modal-overlay" class="note-image-modal-overlay" style="display: none;">
                                    <div class="note-image-modal">
                                        <div class="note-image-modal-header">
                                            <span class="note-image-modal-title"><i class="ri-image-line"></i> <span>Перегляд фото</span></span>
                                            <div class="note-image-modal-actions">
                                                <button type="button" class="notes-btn-action" id="note-modal-copy-img-btn" title="Скопіювати фото в буфер обміну">
                                                    <i class="ri-file-copy-line"></i> <span class="btn-text">Копіювати фото</span>
                                                </button>
                                                <a id="note-modal-download-img-btn" class="notes-btn-action" href="#" download="note-photo" title="Завантажити фото">
                                                    <i class="ri-download-line"></i> <span class="btn-text">Завантажити</span>
                                                </a>
                                                <button type="button" class="note-image-modal-close" id="note-image-modal-close" title="Закрити"><i class="ri-close-line"></i></button>
                                            </div>
                                        </div>
                                        <div class="note-image-modal-body">
                                            <img id="note-image-modal-img" src="" alt="Перегляд фото">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Трекер звичок -->
                <div id="habits" class="tab-panel">
<div class="tab-panel-header">
                        <button class="sub-tab-button active is-static" type="button" aria-disabled="true" tabindex="-1">
                            <i class="ri-calendar-check-line sub-tab-icon"></i>
                            <span>Мої звички</span>
                        </button>
                        <div class="tab-header-right">
                            <button id="add-habit-btn" class="add-data-table-item" onclick="window.openAddHabitModal && window.openAddHabitModal()">
                                <i class="ri-add-line sub-tab-icon"></i>
                                <span>Додати звичку</span>
                            </button>
                        </div>
                    </div>
                    <div id="habits-grid" class="habits-grid">
                        <!-- Звички рендеряться тут -->
                    </div>
                </div>

                <!-- Помодоро -->
                <div id="pomodoro" class="tab-panel">
<div class="tab-panel-header">
                        <button class="sub-tab-button active" data-sub-tab="pomodoro-timer">
                            <i class="ri-timer-line sub-tab-icon"></i>
                            <span>Таймер Помодоро</span>
                        </button>
                        <button class="sub-tab-button" data-sub-tab="pomodoro-stats">
                            <i class="ri-bar-chart-box-line sub-tab-icon"></i>
                            <span>Статистика сесій</span>
                        </button>

                        <div class="tab-header-right">
                            <button class="add-data-table-item" id="pomodoro-quick-start-btn">
                                <i class="ri-play-line sub-tab-icon"></i>
                                <span>Запустити 25хв</span>
                            </button>
                        </div>
                    </div>

                    <div class="sub-tab-content">
                        <div class="sub-tab-panel active" id="pomodoro-timer-content">
                            <div class="pomodoro-wrapper">
                                <div class="pomodoro-container">
                                    <!-- Mode Selector Pills -->
                                    <div class="pomodoro-modes">
                                        <button class="pomo-mode-btn active" data-mode="focus" data-time="25">
                                            <i class="ri-focus-3-line"></i>
                                            <span>25 хв Фокус</span>
                                        </button>
                                        <button class="pomo-mode-btn" data-mode="shortBreak" data-time="5">
                                            <i class="ri-cup-line"></i>
                                            <span>5 хв Перерва</span>
                                        </button>
                                        <button class="pomo-mode-btn" data-mode="longBreak" data-time="15">
                                            <i class="ri-rest-time-line"></i>
                                            <span>15 хв Відпочинок</span>
                                        </button>
                                        <button class="pomo-mode-btn" data-mode="deepWork" data-time="50">
                                            <i class="ri-flashlight-line"></i>
                                            <span>50 хв Праця</span>
                                        </button>
                                    </div>

                                    <!-- Circular Timer Display -->
                                    <div class="pomodoro-circle-wrapper">
                                        <svg class="pomodoro-ring" width="300" height="300" viewBox="0 0 300 300">
                                            <defs>
                                                <linearGradient id="pomoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" stop-color="#38bdf8" />
                                                    <stop offset="50%" stop-color="#3b82f6" />
                                                    <stop offset="100%" stop-color="#60a5fa" />
                                                </linearGradient>
                                                <linearGradient id="pomoBreakGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" stop-color="#34d399" />
                                                    <stop offset="50%" stop-color="#10b981" />
                                                    <stop offset="100%" stop-color="#059669" />
                                                </linearGradient>
                                            </defs>
                                            <circle class="ring-bg" cx="150" cy="150" r="130" />
                                            <circle class="ring-progress" id="pomodoro-progress-circle" cx="150" cy="150" r="130" />
                                        </svg>

                                        <div class="pomodoro-timer-center">
                                            <span id="pomodoro-mode-label" class="pomodoro-mode-label">Фокус сесія</span>
                                            <h2 id="pomodoro-timer-display" class="pomodoro-timer-display">25:00</h2>
                                            <span id="pomodoro-status-hint" class="pomodoro-status-hint">Натисніть Старт для початку</span>
                                        </div>
                                    </div>

                                    <!-- Action Controls -->
                                    <div class="pomodoro-controls">
                                        <button id="pomodoro-start-btn" class="pomodoro-btn pomodoro-btn-primary">
                                            <i class="ri-play-fill"></i> Старт
                                        </button>
                                        <button id="pomodoro-pause-btn" class="pomodoro-btn pomodoro-btn-pause" style="display: none;">
                                            <i class="ri-pause-fill"></i> Пауза
                                        </button>
                                        <button id="pomodoro-add5-btn" class="pomodoro-btn pomodoro-btn-secondary" title="Додати 5 хвилин">
                                            <i class="ri-add-line"></i> +5 хв
                                        </button>
                                        <button id="pomodoro-reset-btn" class="pomodoro-btn pomodoro-btn-secondary" title="Скинути таймер">
                                            <i class="ri-refresh-line"></i>
                                        </button>
                                    </div>

                                    <!-- Daily Summary Stats -->
                                    <div class="pomodoro-stats-cards">
                                        <div class="pomo-stat-card">
                                            <i class="ri-fire-line stat-icon"></i>
                                            <div class="stat-info">
                                                <span class="stat-val" id="pomo-completed-count">0</span>
                                                <span class="stat-lbl">Сесій сьогодні</span>
                                            </div>
                                        </div>
                                        <div class="pomo-stat-card">
                                            <i class="ri-time-line stat-icon"></i>
                                            <div class="stat-info">
                                                <span class="stat-val" id="pomo-completed-minutes">0 хв</span>
                                                <span class="stat-lbl">Час у фокусі</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="sub-tab-panel" id="pomodoro-stats-content">
                            <div class="data-table-container">
                                <table class="data-table">
                                    <thead>
                                        <tr>
                                            <th class="col-date sortable" data-sort="completed_at">Дата та час</th>
                                            <th class="col-limit">Тривалість</th>
                                            <th class="col-name">Нотатка / Опис</th>
                                        </tr>
                                    </thead>
                                    <tbody id="pomodoro-stats-table-tbody"></tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                </div> <!-- .tab-content -->
            </div> <!-- .tab-container -->
        </main> <!-- .main-content -->
    </div> <!-- .app-layout -->

    <!-- Modal for adding a new project -->
    <div id="add-project-modal" class="custom-modal project-modal">
        <div class="custom-modal-content edit-modal-wide project-modal-content">
            <h3 class="custom-modal-title">Додати проєкт</h3>

            <div class="modal-form-scroll">
            <div class="modal-form-grid project-modal-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="project-modal-name">Назва проєкту *</label>
                    <input type="text" id="project-modal-name" class="field-input" autocomplete="off" placeholder="Введіть назву проєкту..."
                        maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="project-modal-status">Статус</label>
                    <div class="field-select-wrap">
                        <select id="project-modal-status" class="field-select">
                            <option value="Активний">Активний</option>
                            <option value="В розробці">В розробці</option>
                            <option value="Завершений">Завершений</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="project-modal-progress">Прогрес виконання (%)</label>
                    <div class="project-progress-range-wrap">
                        <input type="range" id="project-modal-progress" class="field-range" min="0" max="100" value="0">
                        <span class="project-progress-val-badge" id="project-modal-progress-val">0%</span>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label" for="project-modal-desc">Опис або примітки</label>
                    <textarea id="project-modal-desc" class="field-textarea project-modal-textarea" rows="2" placeholder="Додаткові деталі, посилання..."></textarea>
                </div>

                <div class="form-group full-width project-shopping-section">
                    <div class="project-shopping-header">
                        <div class="project-shopping-title">
                            <i class="ri-checkbox-multiple-line"></i>
                            <span>Чекліст / Матеріали / Покупки</span>
                        </div>
                        <span class="project-shopping-summary" id="project-shopping-summary-badge">0 пунктів</span>
                    </div>

                    <div class="project-shopping-add-row">
                        <input type="text" id="project-shop-item-name" class="field-input shop-input-name" autocomplete="off" placeholder="Пункт, матеріал або дія...">
                        <input type="text" id="project-shop-item-qty" class="field-input shop-input-qty" autocomplete="off" placeholder="К-сть">
                        <input type="number" id="project-shop-item-price" class="field-input shop-input-price" autocomplete="off" placeholder="Ціна, ₴" min="0" step="any">
                        <input type="url" id="project-shop-item-url" class="field-input shop-input-url" autocomplete="off" placeholder="🔗 Посилання (URL)">
                        <button type="button" class="btn-shop-add" id="btn-project-add-shop-item"><i class="ri-add-line"></i> Додати</button>
                    </div>

                    <div class="project-shopping-list-box">
                        <table class="project-shopping-table">
                            <thead>
                                <tr>
                                    <th style="width: 34px;"></th>
                                    <th>Пункт / Матеріал</th>
                                    <th style="width: 86px;">К-сть</th>
                                    <th style="width: 105px;">Ціна, ₴</th>
                                    <th style="width: 64px; text-align: right;">Дії</th>
                                </tr>
                            </thead>
                            <tbody id="project-shop-items-tbody"></tbody>
                        </table>
                    </div>
                </div>
            </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelProjectPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="saveProject()">Зберегти</button>
            </div>
        </div>
    </div>

    <!-- Modal for editing a project -->
    <div id="edit-project-modal" class="custom-modal project-modal">
        <div class="custom-modal-content edit-modal-wide project-modal-content">
            <h3 class="custom-modal-title">Редагувати проєкт</h3>

            <div class="modal-form-scroll">
            <div class="modal-form-grid project-modal-grid">
                <div class="form-group">
                    <label class="field-label" for="edit-project-modal-name">Назва проєкту *</label>
                    <input type="text" id="edit-project-modal-name" class="field-input" autocomplete="off" placeholder="Назва..."
                        maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-project-modal-date">Дата створення</label>
                    <div class="date-field-wrap">
                        <input type="text" id="edit-project-modal-date" class="field-input date-time-input" data-no-ghost="1"
                            placeholder="ДД.ММ.РРРР ГГ:ХХ" maxlength="16" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                        <button type="button" class="date-picker-trigger" data-target-input="edit-project-modal-date"
                            aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-project-modal-status">Статус</label>
                    <div class="field-select-wrap">
                        <select id="edit-project-modal-status" class="field-select">
                            <option value="Активний">Активний</option>
                            <option value="В розробці">В розробці</option>
                            <option value="Завершений">Завершений</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-project-modal-progress">Прогрес виконання (%)</label>
                    <div class="project-progress-range-wrap">
                        <input type="range" id="edit-project-modal-progress" class="field-range" min="0" max="100" value="0">
                        <span class="project-progress-val-badge" id="edit-project-modal-progress-val">0%</span>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label" for="edit-project-modal-desc">Опис або примітки</label>
                    <textarea id="edit-project-modal-desc" class="field-textarea project-modal-textarea" rows="2" placeholder="Додаткові деталі, посилання..."></textarea>
                </div>

                <div class="form-group full-width project-shopping-section">
                    <div class="project-shopping-header">
                        <div class="project-shopping-title">
                            <i class="ri-checkbox-multiple-line"></i>
                            <span>Чекліст / Матеріали / Покупки</span>
                        </div>
                        <span class="project-shopping-summary" id="edit-project-shopping-summary-badge">0 пунктів</span>
                    </div>

                    <div class="project-shopping-add-row">
                        <input type="text" id="edit-project-shop-item-name" class="field-input shop-input-name" autocomplete="off" placeholder="Пункт, матеріал або дія...">
                        <input type="text" id="edit-project-shop-item-qty" class="field-input shop-input-qty" autocomplete="off" placeholder="К-сть">
                        <input type="number" id="edit-project-shop-item-price" class="field-input shop-input-price" autocomplete="off" placeholder="Ціна, ₴" min="0" step="any">
                        <input type="url" id="edit-project-shop-item-url" class="field-input shop-input-url" autocomplete="off" placeholder="🔗 Посилання (URL)">
                        <button type="button" class="btn-shop-add" id="btn-edit-project-add-shop-item"><i class="ri-add-line"></i> Додати</button>
                    </div>

                    <div class="project-shopping-list-box">
                        <table class="project-shopping-table">
                            <thead>
                                <tr>
                                    <th style="width: 34px;"></th>
                                    <th>Пункт / Матеріал</th>
                                    <th style="width: 86px;">К-сть</th>
                                    <th style="width: 105px;">Ціна, ₴</th>
                                    <th style="width: 64px; text-align: right;">Дії</th>
                                </tr>
                            </thead>
                            <tbody id="edit-project-shop-items-tbody"></tbody>
                        </table>
                    </div>
                </div>
            </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelEditProjectPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="updateProject()">Зберегти зміни</button>
            </div>
        </div>
    </div>

    <!-- Modals for Expense Management -->
    <div class="add-expense-panel add-edit-project-panel legacy-modal" style="display: none;">
        <div class="add-edit-project-panel-header">
            <h3 class="add-edit-project-panel-title">Нова витрата</h3>
        </div>
        <div class="add-edit-project-panel-content">
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-date">Дата та час</label>
                    <input type="text" id="expense-date" class="date-time-input"
                        placeholder="ДД.ММ.РРРР ГГ:ХХ" maxlength="16" inputmode="numeric"
                        autocomplete="off">
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-type">Тип витрати</label>
                    <div class="custom-select" data-input-id="expense-type">
                        <button type="button" class="custom-select-toggle">Магазин</button>
                        <ul class="custom-select-menu" role="listbox">
                            <li class="custom-select-option is-selected" role="option"
                                aria-selected="true" data-value="Магазин">Магазин</li>
                            <li class="custom-select-option" role="option"
                                data-value="Транспорт">Транспорт</li>
                            <li class="custom-select-option" role="option"
                                data-value="Харчування">Харчування</li>
                            <li class="custom-select-option" role="option"
                                data-value="Розваги">Розваги</li>
                            <li class="custom-select-option" role="option"
                                data-value="Квартира">Квартира</li>
                            <li class="custom-select-option" role="option"
                                data-value="Комунальні">Комунальні</li>
                            <li class="custom-select-option" role="option"
                                data-value="Інтернет / Зв'язок">Інтернет / Зв'язок</li>
                            <li class="custom-select-option" role="option"
                                data-value="Здоров'я">Здоров'я</li>
                            <li class="custom-select-option" role="option"
                                data-value="Велика покупка / Техніка">Велика покупка / Техніка</li>
                            <li class="custom-select-option" role="option"
                                data-value="Інше">Інше</li>
                        </ul>
                        <input type="hidden" id="expense-type" value="Магазин">
                    </div>
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-store">Магазин / Місце</label>
                    <input type="text" id="expense-store" placeholder="Напр. АТБ, Сільпо..."
                        maxlength="255">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-amount">Сума</label>
                    <div class="field-number-wrap">
                        <input type="number" id="expense-amount" class="field-input field-input-number" placeholder="0.00" step="0.01" data-step="100">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="expense-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="expense-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                        </div>
                    </div>
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-currency">Валюта</label>
                    <input type="text" id="expense-currency" placeholder="UAH"
                        maxlength="10" value="UAH">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="expense-description">Опис</label>
                    <input type="text" id="expense-description"
                        placeholder="Додаткова інформація..." maxlength="500">
                </div>
            </div>
            <div class="add-edit-project-panel-row" style="margin-top: 6px;">
                <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; user-select: none;">
                    <input type="checkbox" id="expense-is-extra" style="width: 17px; height: 17px; accent-color: #8b5cf6; cursor: pointer;">
                    <span style="font-size: 13px; color: var(--text-title); font-weight: 500;">
                        Поза щомісячним лімітом <span style="font-size: 12px; color: var(--text-dim); font-weight: 400;">(велика покупка / техніка / з накопичень)</span>
                    </span>
                </label>
            </div>
        </div>
        <div class="add-edit-project-panel-actions">
            <button class="btn-save" title="Зберегти" onclick="saveExpense()">Зберегти</button>
            <button class="btn-cancel" title="Скасувати"
                onclick="cancelExpensePanel()">Скасувати</button>
        </div>
    </div>

    <div class="edit-expense-panel add-edit-project-panel legacy-modal" style="display: none;">
        <div class="add-edit-project-panel-header">
            <h3 class="add-edit-project-panel-title">Редагування витрати</h3>
        </div>
        <div class="add-edit-project-panel-content">
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-date">Дата та час</label>
                    <input type="text" id="edit-expense-date" class="date-time-input"
                        placeholder="ДД.ММ.РРРР ГГ:ХХ" maxlength="16" inputmode="numeric"
                        autocomplete="off">
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-type">Тип витрати</label>
                    <div class="custom-select" data-input-id="edit-expense-type">
                        <button type="button" class="custom-select-toggle">Магазин</button>
                        <ul class="custom-select-menu" role="listbox">
                            <li class="custom-select-option is-selected" role="option"
                                aria-selected="true" data-value="Магазин">Магазин</li>
                            <li class="custom-select-option" role="option"
                                data-value="Транспорт">Транспорт</li>
                            <li class="custom-select-option" role="option"
                                data-value="Харчування">Харчування</li>
                            <li class="custom-select-option" role="option"
                                data-value="Розваги">Розваги</li>
                            <li class="custom-select-option" role="option"
                                data-value="Квартира">Квартира</li>
                            <li class="custom-select-option" role="option"
                                data-value="Комунальні">Комунальні</li>
                            <li class="custom-select-option" role="option"
                                data-value="Інтернет / Зв'язок">Інтернет / Зв'язок</li>
                            <li class="custom-select-option" role="option"
                                data-value="Здоров'я">Здоров'я</li>
                            <li class="custom-select-option" role="option"
                                data-value="Велика покупка / Техніка">Велика покупка / Техніка</li>
                            <li class="custom-select-option" role="option"
                                data-value="Інше">Інше</li>
                        </ul>
                        <input type="hidden" id="edit-expense-type" value="Магазин">
                    </div>
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-store">Магазин / Місце</label>
                    <input type="text" id="edit-expense-store"
                        placeholder="Напр. АТБ, Сільпо..." maxlength="255">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-amount">Сума</label>
                    <div class="field-number-wrap">
                        <input type="number" id="edit-expense-amount" class="field-input field-input-number" placeholder="0.00" step="0.01" data-step="100">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="edit-expense-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="edit-expense-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                        </div>
                    </div>
                </div>
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-currency">Валюта</label>
                    <input type="text" id="edit-expense-currency" placeholder="UAH"
                        maxlength="10">
                </div>
            </div>
            <div class="add-edit-project-panel-row">
                <div class="add-edit-project-panel-group">
                    <label class="field-label" for="edit-expense-description">Опис</label>
                    <input type="text" id="edit-expense-description"
                        placeholder="Додаткова інформація..." maxlength="500">
                </div>
            </div>
            <div class="add-edit-project-panel-row" style="margin-top: 6px;">
                <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; user-select: none;">
                    <input type="checkbox" id="edit-expense-is-extra" style="width: 17px; height: 17px; accent-color: #8b5cf6; cursor: pointer;">
                    <span style="font-size: 13px; color: var(--text-title); font-weight: 500;">
                        Поза щомісячним лімітом <span style="font-size: 12px; color: var(--text-dim); font-weight: 400;">(велика покупка / техніка / з накопичень)</span>
                    </span>
                </label>
            </div>
        </div>
        <div class="add-edit-project-panel-actions">
            <button class="btn-save" title="Зберегти" onclick="updateExpense()">Зберегти</button>
            <button class="btn-cancel" title="Скасувати"
                onclick="cancelEditExpensePanel()">Скасувати</button>
        </div>
    </div>

    <!-- Modal for adding a new task -->
    <div id="add-task-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Додати завдання</h3>

            <div class="modal-form-scroll">
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label">Завдання</label>
                    <input type="text" id="task-title" class="field-input" placeholder="Що потрібно зробити?" maxlength="100">
                    <div class="field-meta">Макс. 100 символів</div>
                </div>

                <div class="form-group">
                    <label class="field-label">Дата</label>
                    <div class="date-field-wrap task-date-field-wrap">
                        <input type="text" id="task-date" class="field-input task-date-input" data-no-ghost="1"
                            placeholder="дд.мм.рррр" maxlength="10" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d$">
                        <button type="button" class="date-today-trigger" data-target-date-input="task-date"
                            aria-label="Встановити сьогоднішню дату">Сьогодні</button>
                        <div class="date-shift-controls" aria-label="Зміна дати на 1 день">
                            <button type="button" class="date-shift-trigger date-shift-up" data-shift-days="1"
                                data-target-date-input="task-date" aria-label="Збільшити дату на 1 день">
                                <i class="ri-add-line"></i>
                            </button>
                            <button type="button" class="date-shift-trigger date-shift-down" data-shift-days="-1"
                                data-target-date-input="task-date" aria-label="Зменшити дату на 1 день">
                                <i class="ri-subtract-line"></i>
                            </button>
                        </div>
                        <button type="button" class="date-picker-trigger" data-target-input="task-date"
                            data-target-time-input="task-time" aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="date" class="native-date-picker" data-for-input="task-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Час (необов'язково)</label>
                    <input type="text" id="task-time" class="field-input task-time-input" placeholder="гг:хв"
                        maxlength="5" inputmode="numeric" autocomplete="off"
                        pattern="^([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                </div>

                <div class="form-group">
                    <label class="field-label">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="task-category" class="field-select">
                            <option value="">Немає</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Розваги">Розваги</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Період</label>
                    <div class="field-select-wrap">
                        <select id="task-period" class="field-select">
                            <option value="">Немає</option>
                            <optgroup label="⚡ Робочі та щоденні слоти">
                                <option value="11:00-12:30">ПУМ [Робота-1] (11:00–12:30)</option>
                                <option value="13:30-18:00">Ліцей / Інклюзія [Робота-2] (13:30–18:00)</option>
                                <option value="18:30-22:30">Доставка Glovo + Bolt (18:30–22:30)</option>
                                <option value="17:00-22:00">Доставка Сб пік (17:00–22:00)</option>
                                <option value="09:00-10:30">Ранок / Побут &amp; сніданок (09:00–10:30)</option>
                                <option value="12:30-13:00">Обід &amp; перепочинок (12:30–13:00)</option>
                                <option value="22:30-24:00">Вечір &amp; особистий час (22:30–24:00)</option>
                            </optgroup>
                            <optgroup label="🕒 Стандартні часові інтервали">
                                <option value="09:00-12:00">Ранок (09:00–12:00)</option>
                                <option value="12:00-15:00">День (12:00–15:00)</option>
                                <option value="15:00-18:00">Вечір (15:00–18:00)</option>
                                <option value="18:00-21:00">Пізній вечір (18:00–21:00)</option>
                            </optgroup>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Ліміт (хв)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="task-limit" class="field-input field-input-number" placeholder="60">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="task-limit"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="task-limit"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Повторення</label>
                    <div class="field-select-wrap">
                        <select id="task-repeat-type" class="field-select">
                            <option value="none">Не повторювати</option>
                            <option value="daily">Кожен день</option>
                            <option value="weekdays">Робочі дні (Пн-Пт)</option>
                            <option value="custom">Вибір днів тижня</option>
                        </select>
                    </div>
                </div>

                <div class="form-group full-width task-repeat-days-group" id="task-repeat-days-wrap" style="display: none;">
                    <label class="field-label">Дні тижня</label>
                    <div class="task-repeat-days-picker" id="task-repeat-days-picker">
                        <button type="button" class="repeat-day-btn" data-day="1">Пн</button>
                        <button type="button" class="repeat-day-btn" data-day="2">Вт</button>
                        <button type="button" class="repeat-day-btn" data-day="3">Ср</button>
                        <button type="button" class="repeat-day-btn" data-day="4">Чт</button>
                        <button type="button" class="repeat-day-btn" data-day="5">Пт</button>
                        <button type="button" class="repeat-day-btn" data-day="6">Сб</button>
                        <button type="button" class="repeat-day-btn" data-day="7">Нд</button>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Опис</label>
                    <textarea id="task-desc" class="field-textarea" rows="3"
                        placeholder="Додаткові деталі..."></textarea>
                </div>

                <div class="form-group full-width task-subtasks-group">
                    <label class="field-label"><i class="ri-checkbox-multiple-line"></i> Підзавдання (чекліст)</label>
                    <div class="subtask-add-row">
                        <input type="text" id="task-subtask-input" class="field-input" placeholder="Додати підзавдання / пункт чекліста..." maxlength="150">
                        <button type="button" class="btn-subtask-add" id="btn-add-subtask"><i class="ri-add-line"></i> Додати</button>
                    </div>
                    <div class="subtasks-list-container" id="task-subtasks-list"></div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Теги (через пробіл)</label>
                    <input type="text" id="task-tags" class="field-input" placeholder="#терміново #важливо">
                </div>

                <div class="form-group full-width checkbox-group" id="task-auto-complete-group" style="display:none;">
                    <input type="checkbox" id="task-auto-complete">
                    <label for="task-auto-complete">Автозавершення після ліміту</label>
                </div>
            </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelTaskPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="saveTask()">Зберегти</button>
            </div>
        </div>
    </div>

    <!-- Modal for editing a task -->
    <div id="edit-task-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Редагувати завдання</h3>

            <div class="modal-form-scroll">
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label">Завдання</label>
                    <input type="text" id="edit-task-title" class="field-input" maxlength="100">
                    <div class="field-meta">Макс. 100 символів</div>
                </div>

                <div class="form-group">
                    <label class="field-label">Дата</label>
                    <div class="date-field-wrap task-date-field-wrap">
                        <input type="text" id="edit-task-date" class="field-input task-date-input" data-no-ghost="1"
                            placeholder="дд.мм.рррр" maxlength="10" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d$">
                        <button type="button" class="date-today-trigger" data-target-date-input="edit-task-date"
                            aria-label="Встановити сьогоднішню дату">Сьогодні</button>
                        <div class="date-shift-controls" aria-label="Зміна дати на 1 день">
                            <button type="button" class="date-shift-trigger date-shift-up" data-shift-days="1"
                                data-target-date-input="edit-task-date" aria-label="Збільшити дату на 1 день">
                                <i class="ri-add-line"></i>
                            </button>
                            <button type="button" class="date-shift-trigger date-shift-down" data-shift-days="-1"
                                data-target-date-input="edit-task-date" aria-label="Зменшити дату на 1 день">
                                <i class="ri-subtract-line"></i>
                            </button>
                        </div>
                        <button type="button" class="date-picker-trigger" data-target-input="edit-task-date"
                            data-target-time-input="edit-task-time" aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="date" class="native-date-picker" data-for-input="edit-task-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Час (необов'язково)</label>
                    <input type="text" id="edit-task-time" class="field-input task-time-input" placeholder="гг:хв"
                        maxlength="5" inputmode="numeric" autocomplete="off"
                        pattern="^([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                </div>

                <div class="form-group">
                    <label class="field-label">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="edit-task-category" class="field-select">
                            <option value="">Немає</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Розваги">Розваги</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Період</label>
                    <div class="field-select-wrap">
                        <select id="edit-task-period" class="field-select">
                            <option value="">Немає</option>
                            <optgroup label="⚡ Робочі та щоденні слоти">
                                <option value="11:00-12:30">ПУМ [Робота-1] (11:00–12:30)</option>
                                <option value="13:30-18:00">Ліцей / Інклюзія [Робота-2] (13:30–18:00)</option>
                                <option value="18:30-22:30">Доставка Glovo + Bolt (18:30–22:30)</option>
                                <option value="17:00-22:00">Доставка Сб пік (17:00–22:00)</option>
                                <option value="09:00-10:30">Ранок / Побут &amp; сніданок (09:00–10:30)</option>
                                <option value="12:30-13:00">Обід &amp; перепочинок (12:30–13:00)</option>
                                <option value="22:30-24:00">Вечір &amp; особистий час (22:30–24:00)</option>
                            </optgroup>
                            <optgroup label="🕒 Стандартні часові інтервали">
                                <option value="09:00-12:00">Ранок (09:00–12:00)</option>
                                <option value="12:00-15:00">День (12:00–15:00)</option>
                                <option value="15:00-18:00">Вечір (15:00–18:00)</option>
                                <option value="18:00-21:00">Пізній вечір (18:00–21:00)</option>
                            </optgroup>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Повторення</label>
                    <div class="field-select-wrap">
                        <select id="edit-task-repeat-type" class="field-select">
                            <option value="none">Не повторювати</option>
                            <option value="daily">Кожен день</option>
                            <option value="weekdays">Робочі дні (Пн-Пт)</option>
                            <option value="custom">Вибір днів тижня</option>
                        </select>
                    </div>
                </div>

                <div class="form-group full-width task-repeat-days-group" id="edit-task-repeat-days-wrap" style="display: none;">
                    <label class="field-label">Дні тижня</label>
                    <div class="task-repeat-days-picker" id="edit-task-repeat-days-picker">
                        <button type="button" class="repeat-day-btn" data-day="1">Пн</button>
                        <button type="button" class="repeat-day-btn" data-day="2">Вт</button>
                        <button type="button" class="repeat-day-btn" data-day="3">Ср</button>
                        <button type="button" class="repeat-day-btn" data-day="4">Чт</button>
                        <button type="button" class="repeat-day-btn" data-day="5">Пт</button>
                        <button type="button" class="repeat-day-btn" data-day="6">Сб</button>
                        <button type="button" class="repeat-day-btn" data-day="7">Нд</button>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Ліміт (хв)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="edit-task-limit" class="field-input field-input-number">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="edit-task-limit"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="edit-task-limit"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Опис</label>
                    <textarea id="edit-task-desc" class="field-textarea" rows="3"></textarea>
                </div>

                <div class="form-group full-width task-subtasks-group">
                    <label class="field-label"><i class="ri-checkbox-multiple-line"></i> Підзавдання (чекліст)</label>
                    <div class="subtask-add-row">
                        <input type="text" id="edit-task-subtask-input" class="field-input" placeholder="Додати підзавдання / пункт чекліста..." maxlength="150">
                        <button type="button" class="btn-subtask-add" id="btn-edit-add-subtask"><i class="ri-add-line"></i> Додати</button>
                    </div>
                    <div class="subtasks-list-container" id="edit-task-subtasks-list"></div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label">Теги (через пробіл)</label>
                    <input type="text" id="edit-task-tags" class="field-input">
                </div>

                <div id="edit-task-auto-complete-group" class="form-group full-width checkbox-group"
                    style="display:none;">
                    <input type="checkbox" id="edit-task-auto-complete">
                    <label for="edit-task-auto-complete">Автозавершення після ліміту</label>
                </div>
            </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelEditTaskPanel()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="updateTask()">Зберегти зміни</button>
            </div>
        </div>
    </div>

    <div id="custom-confirm" class="custom-modal">
        <div class="custom-modal-content confirm-modal-box">
            <div class="confirm-modal-icon-wrap" id="custom-confirm-icon">
                <i class="ri-delete-bin-line"></i>
            </div>
            <h3 class="custom-modal-title" id="custom-confirm-title">Підтвердження дії</h3>
            <p id="custom-confirm-message" class="custom-modal-message"></p>
            <div class="custom-modal-actions">
                <button id="custom-confirm-no" class="btn-secondary" type="button">Скасувати</button>
                <button id="custom-confirm-yes" class="btn-danger" type="button">Видалити</button>
            </div>
        </div>
    </div>

    <div id="add-goal-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Додати ціль</h3>
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="goal-title">Назва цілі</label>
                    <input type="text" id="goal-title" class="field-input" placeholder="Наприклад: Купівля мотоцикла Yamaha R6"
                        maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-type">Тип цілі</label>
                    <div class="field-select-wrap">
                        <select id="goal-type" class="field-select">
                            <option value="general">Звичайна ціль</option>
                            <option value="financial">Матеріальна / Накопичення коштів</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-category">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="goal-category" class="field-select">
                            <option value="Покупки">Покупки</option>
                            <option value="Фінанси">Фінанси</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Здоров'я">Здоров'я</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-status">Статус</label>
                    <div class="field-select-wrap">
                        <select id="goal-status" class="field-select">
                            <option value="Планується">Планується</option>
                            <option value="В процесі">В процесі</option>
                            <option value="Досягнуто">Досягнуто</option>
                            <option value="Відкладено">Відкладено</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="goal-target-date">Дедлайн</label>
                    <div class="date-field-wrap">
                        <input type="text" id="goal-target-date" class="field-input date-time-input"
                            placeholder="дд.мм.рррр гг:хв" maxlength="16" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                        <button type="button" class="date-picker-trigger" data-target-input="goal-target-date"
                            aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="datetime-local" class="native-date-picker" data-for-input="goal-target-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <!-- Блок фінансових цілей -->
                <div id="goal-financial-fields" class="form-group full-width goal-financial-block" style="display: none;">
                    <div class="modal-form-grid" style="grid-template-columns: 1fr 1fr 100px;">
                        <div class="form-group">
                            <label class="field-label" for="goal-target-amount">Цільова сума</label>
                            <div class="field-number-wrap">
                                <input type="number" id="goal-target-amount" class="field-input field-input-number" placeholder="100000" step="100" min="0">
                                <div class="field-number-controls">
                                    <button type="button" class="field-number-btn" data-step-target="goal-target-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                    <button type="button" class="field-number-btn" data-step-target="goal-target-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="goal-current-amount">Накопичено наразі</label>
                            <div class="field-number-wrap">
                                <input type="number" id="goal-current-amount" class="field-input field-input-number" placeholder="0" step="100" min="0">
                                <div class="field-number-controls">
                                    <button type="button" class="field-number-btn" data-step-target="goal-current-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                    <button type="button" class="field-number-btn" data-step-target="goal-current-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="goal-currency">Валюта</label>
                            <div class="field-select-wrap">
                                <select id="goal-currency" class="field-select">
                                    <option value="грн">грн</option>
                                    <option value="$">$</option>
                                    <option value="€">€</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-top: 12px;">
                        <label class="field-label" for="goal-image-url">Зображення цілі (URL або пресет)</label>
                        <input type="text" id="goal-image-url" class="field-input" placeholder="https://images.unsplash.com/...">
                        <div class="goal-image-presets">
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1558981806-ec527fa84c39?auto=format&fit=crop&w=800&q=80">🏍️ Мотоцикл</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80">🚗 Авто</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80">🏠 Будинок</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80">✈️ Подорож</button>
                            <button type="button" class="preset-img-btn" data-target-input="goal-image-url" data-url="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=80">💻 Техніка</button>
                        </div>
                    </div>
                </div>

                <div class="form-group" id="goal-progress-wrap">
                    <label class="field-label" for="goal-progress">Прогрес (%)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="goal-progress" class="field-input field-input-number" min="0" max="100"
                            step="1" value="0">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="goal-progress"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="goal-progress"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label" for="goal-description">Опис</label>
                    <textarea id="goal-description" class="field-textarea" rows="3"
                        placeholder="Коротко опишіть ціль..."></textarea>
                </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelAddGoalDialog()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="saveGoal()">Зберегти</button>
            </div>
        </div>
    </div>

    <div id="edit-goal-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-wide">
            <h3 class="custom-modal-title">Редагувати ціль</h3>
            <input type="hidden" id="edit-goal-id">
            <div class="modal-form-grid">
                <div class="form-group full-width">
                    <label class="field-label" for="edit-goal-title">Назва цілі</label>
                    <input type="text" id="edit-goal-title" class="field-input" maxlength="255">
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-type">Тип цілі</label>
                    <div class="field-select-wrap">
                        <select id="edit-goal-type" class="field-select">
                            <option value="general">Звичайна ціль</option>
                            <option value="financial">Матеріальна / Накопичення коштів</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-category">Категорія</label>
                    <div class="field-select-wrap">
                        <select id="edit-goal-category" class="field-select">
                            <option value="Покупки">Покупки</option>
                            <option value="Фінанси">Фінанси</option>
                            <option value="Робота">Робота</option>
                            <option value="Особисте">Особисте</option>
                            <option value="Навчання">Навчання</option>
                            <option value="Здоров'я">Здоров'я</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-status">Статус</label>
                    <div class="field-select-wrap">
                        <select id="edit-goal-status" class="field-select">
                            <option value="Планується">Планується</option>
                            <option value="В процесі">В процесі</option>
                            <option value="Досягнуто">Досягнуто</option>
                            <option value="Відкладено">Відкладено</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label" for="edit-goal-target-date">Дедлайн</label>
                    <div class="date-field-wrap">
                        <input type="text" id="edit-goal-target-date" class="field-input date-time-input"
                            placeholder="дд.мм.рррр гг:хв" maxlength="16" inputmode="numeric" autocomplete="off"
                            pattern="^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$">
                        <button type="button" class="date-picker-trigger" data-target-input="edit-goal-target-date"
                            aria-label="Відкрити календар">
                            <i class="ri-calendar-line"></i>
                        </button>
                        <input type="datetime-local" class="native-date-picker" data-for-input="edit-goal-target-date"
                            tabindex="-1" aria-hidden="true">
                    </div>
                </div>

                <!-- Блок фінансових цілей -->
                <div id="edit-goal-financial-fields" class="form-group full-width goal-financial-block" style="display: none;">
                    <div class="modal-form-grid" style="grid-template-columns: 1fr 1fr 100px;">
                        <div class="form-group">
                            <label class="field-label" for="edit-goal-target-amount">Цільова сума</label>
                            <div class="field-number-wrap">
                                <input type="number" id="edit-goal-target-amount" class="field-input field-input-number" placeholder="100000" step="100" min="0">
                                <div class="field-number-controls">
                                    <button type="button" class="field-number-btn" data-step-target="edit-goal-target-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                    <button type="button" class="field-number-btn" data-step-target="edit-goal-target-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="edit-goal-current-amount">Накопичено наразі</label>
                            <div class="field-number-wrap">
                                <input type="number" id="edit-goal-current-amount" class="field-input field-input-number" placeholder="0" step="100" min="0">
                                <div class="field-number-controls">
                                    <button type="button" class="field-number-btn" data-step-target="edit-goal-current-amount" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                                    <button type="button" class="field-number-btn" data-step-target="edit-goal-current-amount" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="field-label" for="edit-goal-currency">Валюта</label>
                            <div class="field-select-wrap">
                                <select id="edit-goal-currency" class="field-select">
                                    <option value="грн">грн</option>
                                    <option value="$">$</option>
                                    <option value="€">€</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="margin-top: 12px;">
                        <label class="field-label" for="edit-goal-image-url">Зображення цілі (URL або пресет)</label>
                        <input type="text" id="edit-goal-image-url" class="field-input" placeholder="https://images.unsplash.com/...">
                        <div class="goal-image-presets">
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1558981806-ec527fa84c39?auto=format&fit=crop&w=800&q=80">🏍️ Мотоцикл</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80">🚗 Авто</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80">🏠 Будинок</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80">✈️ Подорож</button>
                            <button type="button" class="preset-img-btn" data-target-input="edit-goal-image-url" data-url="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=80">💻 Техніка</button>
                        </div>
                    </div>
                </div>

                <div class="form-group" id="edit-goal-progress-wrap">
                    <label class="field-label" for="edit-goal-progress">Прогрес (%)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="edit-goal-progress" class="field-input field-input-number" min="0"
                            max="100" step="1">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="edit-goal-progress"
                                data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="edit-goal-progress"
                                data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                        </div>
                    </div>
                </div>

                <div class="form-group full-width">
                    <label class="field-label" for="edit-goal-description">Опис</label>
                    <textarea id="edit-goal-description" class="field-textarea" rows="3"></textarea>
                </div>
            </div>

            <div class="custom-modal-actions">
                <button class="btn-secondary" onclick="cancelEditGoalDialog()">Скасувати</button>
                <button class="btn-danger" style="background: var(--text-main); color: var(--bg-app);"
                    onclick="updateGoal()">Зберегти зміни</button>
            </div>
        </div>
    </div>

    <!-- Модальне вікно швидкого поповнення цілі -->
    <div id="deposit-goal-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-small">
            <h3 class="custom-modal-title"><i class="ri-wallet-3-line"></i> Поповнити ціль</h3>
            <input type="hidden" id="deposit-goal-id">
            <div class="modal-form-grid">
                <div class="form-group full-width" style="text-align: center; margin-bottom: 8px;">
                    <div id="deposit-goal-name" style="font-size: 16px; font-weight: 700; color: var(--text-title);"></div>
                    <div id="deposit-goal-info" style="font-size: 13px; color: var(--text-muted); margin-top: 4px;"></div>
                </div>
                <div class="form-group full-width">
                    <label class="field-label" for="deposit-amount-input">Сума поповнення (+)</label>
                    <div class="field-number-wrap">
                        <input type="number" id="deposit-amount-input" class="field-input field-input-number" placeholder="Наприклад: 5000" step="100" min="1">
                        <div class="field-number-controls">
                            <button type="button" class="field-number-btn" data-step-target="deposit-amount-input" data-step-dir="up" aria-label="Збільшити"><i class="ri-arrow-up-s-line"></i></button>
                            <button type="button" class="field-number-btn" data-step-target="deposit-amount-input" data-step-dir="down" aria-label="Зменшити"><i class="ri-arrow-down-s-line"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-modal-actions" style="margin-top: 16px;">
                <button class="btn-secondary" onclick="cancelDepositGoalDialog()">Скасувати</button>
                <button class="btn-danger" style="background: #3b82f6; color: #fff;" onclick="saveDepositGoal()">Поповнити</button>
            </div>
        </div>
    </div>

    <!-- Модальне вікно створення нової звички -->
    <div id="add-habit-modal" class="custom-modal">
        <div class="custom-modal-content edit-modal-small">
            <h3 class="custom-modal-title"><i class="ri-calendar-check-line"></i> Створити нову звичку</h3>
            <div class="modal-form-grid" style="grid-template-columns: 1fr; gap: 16px;">
                <div class="form-group">
                    <label class="field-label" for="habit-name-input">Назва звички *</label>
                    <input type="text" id="habit-name-input" class="field-input" placeholder="Наприклад: Пити 2л води, Читання 20хв..." autocomplete="off">
                </div>
                <div class="form-group">
                    <label class="field-label" for="habit-desc-input">Опис (необов'язково)</label>
                    <input type="text" id="habit-desc-input" class="field-input" placeholder="Короткий опис або ціль..." autocomplete="off">
                </div>
                <div class="form-group">
                    <label class="field-label">Колір акценту</label>
                    <div style="display: flex; gap: 12px; align-items: center; margin-top: 6px;">
                        <input type="color" id="habit-color-input" value="#10b981" style="width: 44px; height: 38px; border: none; background: transparent; cursor: pointer;">
                        <span style="font-size: 12px; color: var(--text-dim);">Оберіть колір для картки та індикатора</span>
                    </div>
                </div>
            </div>
            <div class="custom-modal-actions" style="margin-top: 20px;">
                <button type="button" class="btn-secondary" id="add-habit-cancel-btn" onclick="window.closeAddHabitModal && window.closeAddHabitModal()">Скасувати</button>
                <button type="button" class="btn-danger" style="background: #10b981; color: #fff;" id="add-habit-save-btn" onclick="window.saveHabitFromModal && window.saveHabitFromModal()">Створити звичку</button>
            </div>
        </div>
    </div>

    <script type="module" src="/src/js/main.ts"></script>
</body>

</html>
